import { useTheme } from "@emotion/react";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ButtonBase, InputBase, Popper } from "@mui/material";
import cx from 'classnames';
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as yup from "yup";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MAddInboundLine from "../../../../components/global/Modals/MAddInboundLine";
import MConfirmationWithValue from "../../../../components/global/Modals/MConfirmationWithValue";
import MConfirmDelete from "../../../../components/global/Modals/MConfirmDelete.jsx";
import MUpdateBatch from "../../../../components/global/Modals/MUpdateBatch.jsx";
import MUpdateLot from "../../../../components/global/Modals/MUpdateLot.jsx";
import Shbutton from "../../../../components/theme/buttons/Shbutton.jsx";
import ShSwitch from "../../../../components/theme/inputs/ShSwitch.jsx";
import SelectGroup from "../../../../components/theme/Select/SelectGroup.jsx";
import ShDateRangePicker from "../../../../components/theme/ShDateRangePicker.jsx";
import ShValidatedInputDropdown from "../../../../components/theme/dropdowns/ShValidatedInputDropdown.jsx";
import Heading from "../../../../components/theme/text/Heading.jsx";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import Subheading from "../../../../components/theme/text/Subheading.jsx";
import Text from "../../../../components/theme/text/Text.jsx";
import { setWorkSpace } from "../../../../newapi/global/settingsSlice.js";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice.js";
import { UserPrivileges } from "../../../../utils/permissions.js";
import { useCreateBatchMutation, useDeleteBatchMutation } from "../../../../newapi/inbound/batches.js";
import { usePreRegisterInboundLineMutation, useRegisterCountInboundLineMutation, useCompleteInboundMutation, useReceiveSerialNumberMutation, useGetInboundLinePhotosQuery, useUploadInboundLinePhotoMutation, useDeleteInboundLinePhotoMutation, useGetInboundShipmentsQuery, useDeleteInboundShipmentMutation } from "../../../../newapi/inbound/inboundsSlice.js";
import MAddInboundShipments from "../../../../components/global/Modals/MAddInboundShipments.jsx";
import MUpdateInboundShipment from "../../../../components/global/Modals/MUpdateInboundShipment.jsx";
import LinePhotos from "../../../../components/theme/photos/LinePhotos.jsx";
import MLinePhotoCapture from "../../../../components/global/Modals/MLinePhotoCapture.jsx";
import MPhotoViewer from "../../../../components/global/Modals/MPhotoViewer.jsx";
import { stockhubInboundPreCode } from "../../../../utils/constants.js";
import { useCreateLotMutation, useDeleteLotMutation } from "../../../../newapi/inbound/lots.js";
import { useCreateRepackingOrderMutation } from "../../../../newapi/inbound/repackingorders.js";
import { useUpdateProductMutation, useGetFilteredSuggestedLocationsQuery } from "../../../../newapi/warehouse/productSlice.js";
import { useFindWorkspacesSelectQuery, usePrintBarcodeMutation } from "../../../../newapi/warehouse/workspaceSlice.js";
import { themeSettings, tokens } from "../../../../theme.js";
import { showToastMessageDeleteRequest, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../utils/toasts.js";
import { useGetCarrierForProcessingMutation, useGetCarriersSelectForProcessingMutation, useGetCarriersSelectQuery, useGetFilteredCarriersSelectQuery } from "../../../../newapi/carrier/carrierSlice.js";
import { ShDropdownQuery, DropdownBaseV2 } from "../../../../components/theme/dropdowns/Dropdown.jsx";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AMInboundProcessing from "../../../../components/global/Modals/ActionModal/AMInboundProcessing.jsx";
import MLinkCostToInbound from "../../../../components/global/Modals/MLinkCostToInbound.jsx";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader.js";
import { EditOutlined, LocalPrintshopOutlined, PrintOutlined } from "@mui/icons-material";
import MInboundEditAmountReceived from "../../../../components/global/Modals/MInboundEditAmountReceived.jsx";
import ShLabel from "../../../../components/theme/label/ShLabel.jsx";
import { getInboundStateData, getSerialNumberStateLabeldata, getWarehouseLocationLabelData } from "../../../../utils/labelColorText.js";
import { general_states } from "../../../../utils/staticEnums.js";
import MCreateSerialNumber from "../../../../components/global/Modals/MCreateSerialNumber.jsx";
import { AMInboundToProcess } from "../../../../components/global/Modals/ActionModal/AMInboundToProcess.jsx";
import MAddExtraSerialNumbers from "../../../../components/global/Modals/MAddExtraSerialNumbers.jsx";
import MCreateRepackOrder from "../../../../components/global/Modals/MCreateRepackOrder.jsx";
import MPrintSerialNumberBarcode from "../../../../components/global/Modals/MPrintSerialNumberBarcode.jsx";
import MPrintInboundBarcodes from "../../../../components/global/Modals/MPrintInboundBarcodes.jsx";
import { useGetSettingsQuery } from "../../../../newapi/global/generalApiSlice.js";
import { useGetWarehouseZonesSelectQuery, useGetWarehousesSelectQuery } from "../../../../newapi/warehouse/warehouseApiSlice.js";
import { useGetWarehouseLocationTypesSelectQuery } from "../../../../newapi/warehouse/warehouseLocationTypeSlice.js";
import { useGetWarehouseLocationSelectQuery } from "../../../../newapi/warehouse/warehouselocationSlice.js";
import { useMoveStockMutation } from "../../../../newapi/warehouse/stockSlice.js";
import { PlacePanel } from "./PlacePanel.jsx";
// import SPStockDetails from "../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails.jsx";

const SPStockDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails"));

export const CustomMyComponent = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <ButtonBase
            key={props.key}
            onClick={props.onClick}
            className={cx('',{
                'active': props.isSelected
            })}
            sx={{
                flexShrink:0,
                height:24,
                minWidth:300,
                width:1,
                pl:1.5,
                pr:0.5,
                textAlign:"left",
                display:"flex",
                justifyContent:'space-between',
                alignItems:"center",
                borderRadius:2,
                fontSize:14,
                fontFamily:"Roboto, sans-serif",
                fontWeight:400,
                color:colors.txt['primary'],
                '&.active' : {
                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fontWeight:"900",
                }
            }}
        >
            {props.option.name || props.option.description}

            {props.option.count && 
                <Box 
                    className={cx('',{
                        'active': props.isSelected
                    })}
                    sx={{
                        height:24,
                        background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        display:"flex",
                        justifyContent:'center',
                        alignItems:"center",
                        px:1,
                        borderRadius:2,
                        '&.active' : {
                            background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontWeight:"900",
                        }
                    }}
                >
                    {props.option.count}
                </Box>
            }
        </ButtonBase>
    )
}
const InboundToProcessView = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const dispatch = useDispatch();

    const hasPrintBarcodePermission = useSelector((state) => selectUserPermission(state, [UserPrivileges.BARCODE_PRINT]));
    const hasInboundProcessPcPermission = useSelector((state) => selectUserPermission(state, [UserPrivileges.INBOUND_PROCESS_PC]));
    // Printing all barcodes of the inbound at once is switched on per customer by Stockhub (setup panel)
    const { data: bulkBarcodePrintSettings } = useGetSettingsQuery("inbound_bulk_barcode_print_enabled");
    const bulkBarcodePrintEnabled = hasPrintBarcodePermission && !!bulkBarcodePrintSettings?.some((s) => s.key === "inbound_bulk_barcode_print_enabled" && s.value === "true");

    const [createRepackOrder, setCreateRepackOrder] = useState(false);
    const buttonRef = useRef(null);
    const [inboundLineToProcess, setInboundLineToProcess] = useState(null);
    const [inboundLineToEdit, setInBoundLineToEdit] = useState(null);
    const [skuSearch, setSkuSearch] = useState("");

    // Lines still to receive come first, then partly received, then fully received and completed
    const inboundLineStateOrder = [general_states.ACTIVE, general_states.PARTLYRECEIVED, general_states.FULLYRECEIVED, general_states.COMPLETED];
    const getInboundLineStateRank = (state) => {
        const rank = inboundLineStateOrder.indexOf(state);
        return rank === -1 ? inboundLineStateOrder.length : rank;
    };
    const visibleInboundLines = useMemo(() => {
        const search = skuSearch.trim().toLowerCase();
        return (props.incData?.inboundlines ?? [])
            .filter(line => !search || (line.sku ?? "").toLowerCase().includes(search))
            .sort((a, b) => getInboundLineStateRank(a.state) - getInboundLineStateRank(b.state));
    }, [props.incData?.inboundlines, skuSearch]);

    // Partly received, fully received and completed lines are tinted in the color of their state label
    const getInboundLineStateColor = (state) => {
        if (![general_states.PARTLYRECEIVED, general_states.FULLYRECEIVED, general_states.COMPLETED].includes(state)) return null;
        return colors[getInboundStateData(state, theme).labelcolor];
    };
   
    const [editAmountReceivedModalOpen, setEditAmountReceivedModalOpen] = useState(false);
    const updateAmountReceivedModal = {
        open: editAmountReceivedModalOpen,
        setOpen: setEditAmountReceivedModalOpen
    }

    const handleAmountReicevedClose = (reloadData = false) => {
        setEditAmountReceivedModalOpen(false);
        if(reloadData) {
            props.getInbound(props.incData.id);

             preRegisterInbound({
                inboundId: props.incData.id,
                inboundLineId:inboundLineToEdit.inboundLine.id,
            }).unwrap()
            
            .then(res => {
                setWasCounted(false);
                if(res["success"]){
                    setSelectedCarrier(null);
                    // setInboundLineToProcess(res);
                    setInboundLineToProcess({
                        ...res,
                        flags: {
                            ...res.flags,
                        }
                    })
                    setInBoundLineToEdit({
                        inboundLine:inboundLineToEdit.inboundLine,
                        inboundLineId:inboundLineToEdit.inboundLine.id,
                        dimensionsAndWeight: {
                            ...res.flags.dimensionAndWeightValues,
                            required: res.flags.enterDimensionsAndWeight,
                            hasBeenEditted: false,
                        },
                        lots: res.lots,
                        batches: res.batches,
                        repackingorders: res.repackingorders,
                        amounts:{
                            forecasted: res.inboundLine.amountForecasted,
                            moved: res.inboundLine.amountMoved,
                            received: res.inboundLine.amountReceived,
                            lastReceived: res.inboundLine.lastAmountReceived,
                            counted:'',
                        }
                    })
                    if(countRef.current){
                        countRef.current.focus();
                    }
                } else {
                    props.setHighlightColor("red");
                }
            })
            .catch(err => {
                props.setHighlightColor("red");
            })
        }
    };



    const inputRef = useRef(null);
    const countRef = useRef(null);
    const serialNumberRef = useRef(null);
    const [receiveSerialNumber, {data: serialNumberData, loading:receiveSerialNumberLoading}] = useReceiveSerialNumberMutation();
    const [preRegisterInbound, {data: preRegisterData, loading: preRegisterLoading, fetching: preRegisterFetching}] = usePreRegisterInboundLineMutation();
    const [createBatch, {data: createBatchData, loading: createBatchLoading, isFetching: createBatchFetching}] = useCreateBatchMutation();
    
    const [createLot, {loading: createLotLoading, fetching: createLotFetching}] = useCreateLotMutation();
    const [printBarcode, {loading: printBarcodeLoading, fetching: printBarcodeFetching}] = usePrintBarcodeMutation();
    const [createRepackingOrder, {loading: createRepackingOrderLoading, fetching: createRepackingOrderFetching}] = useCreateRepackingOrderMutation();
    const [countInbound, {loading: countInboundLoading, fetching: countInboundFetching}] = useRegisterCountInboundLineMutation();
    const [updateProduct, {loading: updateProductLoading, fetching: updateProductFetching}] = useUpdateProductMutation();
    const [getCarrier,{}] = useGetCarrierForProcessingMutation();
    const [selectedCarrier, setSelectedCarrier] = useState(null);
    // const  {data: carrierData, loading: carriersLoading, fetching: carriersFetching} = useGetCarriersSelectQuery({},
    //     {
    //         skip: !inboundLineToEdit
    //     }
    // );

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;

    const handleFilterPopoverClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterPopoverClose = () => {
        setFilterAnchorEl(null);
        // setExportAnchorEl(null);
    };

    const [isHovered, setIsHovered] = useState(false);

    const [wasChecked, setWasChecked] = useState(false);
    const [shouldBeShown, setShouldBeShown] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const [wasCounted, setWasCounted] = useState(false);

    const defaultLocationAmount = Math.max(0, (inboundLineToEdit?.amounts?.received ?? 0) - (inboundLineToEdit?.amounts?.moved ?? 0));

    const globalWarehouseId = useSelector(state => state.warehouse.activeId);
    const {data: warehousesData} = useGetWarehousesSelectQuery(undefined, { skip: !hasInboundProcessPcPermission });
    const warehouses = warehousesData?.data ?? [];
    const [selectedLocationWarehouseId, setSelectedLocationWarehouseId] = useState(null);

    useEffect(() => {
        if (!hasInboundProcessPcPermission) return;
        if (globalWarehouseId && globalWarehouseId !== -1) {
            setSelectedLocationWarehouseId(globalWarehouseId);
        } else if (warehouses.length === 1) {
            setSelectedLocationWarehouseId(warehouses[0].id);
        }
    }, [globalWarehouseId, warehouses, hasInboundProcessPcPermission]);

    const locationWarehouseSelected = hasInboundProcessPcPermission && selectedLocationWarehouseId !== null && selectedLocationWarehouseId !== -1;
    const showWarehouseSelector = hasInboundProcessPcPermission && !locationWarehouseSelected && warehouses.length > 1;

    const [locationFilters, setLocationFilters] = useState({
        zones: [],
        carrierId: null,
        warehouseLocationTypeId: null,
        amount: null,
    });

    useEffect(() => {
        if (!hasInboundProcessPcPermission) return;
        setLocationFilters(prev => ({
            ...prev,
            amount: defaultLocationAmount > 0 ? defaultLocationAmount : null,
        }));
    }, [defaultLocationAmount, hasInboundProcessPcPermission]);

    const canFetchLocations = (() => {
        if (!hasInboundProcessPcPermission) return false;
        if (!locationWarehouseSelected) return false;
        if (!inboundLineToEdit?.inboundLine?.productId) return false;
        if (wasCounted) return true;
        return defaultLocationAmount > 0;
    })();

    const locationFilterBody = (() => {
        if (!hasInboundProcessPcPermission) return {};
        const body = {};
        if (locationFilters.warehouseLocationTypeId) {
            body.warehouseLocationTypeId = locationFilters.warehouseLocationTypeId;
        }
        if (locationFilters.zones.length > 0) {
            body.warehouseZone = locationFilters.zones;
        }
        if (locationFilters.carrierId) {
            body.carrierId = locationFilters.carrierId;
        }
        if (locationFilters.amount !== null && locationFilters.amount > 0) {
            body.amount = locationFilters.amount;
        }
        return body;
    })();

    const {data: locations, isLoading: locationsLoading} = useGetFilteredSuggestedLocationsQuery(
        {productId: inboundLineToEdit?.inboundLine?.productId, warehouseId: selectedLocationWarehouseId, filters: locationFilterBody},
        {skip: !canFetchLocations}
    );
    const [lotToUpdate, setLotToUpdate] = useState(null);
    const [batchToUpdate, setBatchToUpdate] = useState(null);

    const [productsSpIsExtended, setProductsSpIsExtended] = useState(false);
    const [spProductLoading, setSpProductLoading] = useState();

    const [photoModalOpen, setPhotoModalOpen] = useState(false);
    const [photoModalMode, setPhotoModalMode] = useState('pc');
    const [photoViewerOpen, setPhotoViewerOpen] = useState(false);
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

    const { data: photosData, refetch: refetchPhotos, isLoading: photosLoading, isFetching: photosFetching } = useGetInboundLinePhotosQuery(
        { inboundId: props.incData?.id, inboundLineId: inboundLineToEdit?.inboundLine?.id },
        { skip: !inboundLineToEdit?.inboundLine?.id }
    );
    const [uploadPhoto, { isLoading: isUploadingPhoto }] = useUploadInboundLinePhotoMutation();
    const [deletePhoto, { isLoading: isDeletingPhoto }] = useDeleteInboundLinePhotoMutation();

    const handleOpenPhotoModal = (mode) => {
        setPhotoModalMode(mode);
        setPhotoModalOpen(true);
    };

    const handlePhotoClick = (index) => {
        setCurrentPhotoIndex(index);
        setPhotoViewerOpen(true);
    };

    const handleUploadPhoto = (file) => uploadPhoto({
        inboundId: props.incData.id,
        inboundLineId: inboundLineToEdit.inboundLine.id,
        file,
    }).unwrap();

    const handleDeletePhoto = async (photoId) => {
        try {
            await deletePhoto({
                inboundId: props.incData.id,
                inboundLineId: inboundLineToEdit.inboundLine.id,
                photoId,
            }).unwrap();
            refetchPhotos();
        } catch (err) {
            toast.error(t("error"));
        }
    };

    // Shipments hang off the inbound, not the line, so they stay loaded for the whole inbound.
    const [addShipmentsModalOpen, setAddShipmentsModalOpen] = useState(false);
    const addShipmentsModal = {
        open: addShipmentsModalOpen,
        setOpen: setAddShipmentsModalOpen
    }

    const { data: shipmentsData } = useGetInboundShipmentsQuery(
        { args: { id: props.incData?.id, page: 1, size: 250, body: {} } },
        { skip: !props.incData?.id }
    );
    const inboundShipments = shipmentsData?.data ?? [];

    const [shipmentToUpdate, setShipmentToUpdate] = useState(null);
    const [updateShipmentModalOpen, setUpdateShipmentModalOpen] = useState(false);
    const updateShipmentModal = {
        open: updateShipmentModalOpen,
        setOpen: setUpdateShipmentModalOpen
    }

    const [shipmentToDelete, setShipmentToDelete] = useState(null);
    const [deleteInboundShipment, {isLoading: deleteInboundShipmentLoading}] = useDeleteInboundShipmentMutation();
    const handleDeleteShipment = async () => {
        if (deleteInboundShipmentLoading || !shipmentToDelete) return;
        try {
            const response = await deleteInboundShipment({ id: shipmentToDelete.id, inboundId: props.incData.id }).unwrap();
            showToastMessageDeleteRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t("delete_failed"), t, err);
        }
        setShipmentToDelete(null);
    };

    const [confirmDeleteShipmentModalOpen, setConfirmDeleteShipmentModalOpen] = useState(false);
    const confirmDeleteShipmentModal = {
        open: confirmDeleteShipmentModalOpen,
        setOpen: setConfirmDeleteShipmentModalOpen,
        confirm: handleDeleteShipment
    }

    const resetWorkspace = () => {
        dispatch(setWorkSpace({
            id: -1,
            name: "workspace_not_set"
        }))
    }
    
    const handleProductFieldValueChange = (fieldId, newValue) => {
        setInBoundLineToEdit(prev => {
            const existingValues = prev.dimensionsAndWeight.productFieldValues || [];
            const existingIndex = existingValues.findIndex(pf => pf.productfieldId === fieldId);

            let updatedValues;
            if (existingIndex !== -1) {
                updatedValues = existingValues.map(pf =>
                    pf.productfieldId === fieldId ? { ...pf, value: newValue } : pf
                );
            } else {
                updatedValues = [...existingValues, { productfieldId: fieldId, value: newValue }];
            }

            return {
                ...prev,
                dimensionsAndWeight: {
                    ...prev.dimensionsAndWeight,
                    hasBeenEditted: true,
                    productFieldValues: updatedValues,
                }
            };
        });
    };

    const initialBatchState = {
        amount:'',
        bbDate:null,
        bbDateWasNotChanged:true,
        number:'',
    }
    const [batchData, setBatchData] = useState(initialBatchState);
    const batchValidationSchema = yup.object().shape({
        number: yup.string()
            .required('Barcode is required'),
        amount: yup.number()
            .typeError('Amount must be a number')
            .required('Amount received is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'), 
        bbDate: yup
            .date()
            .transform((value, originalValue) => {
                return (originalValue === '' || originalValue === null) ? null : new Date(originalValue);
            })
            .typeError('Best before date must be a valid date')
            .required('Best before date is required')
    }); 

    const [item,setItem] = useState(null);
    const [amStreamInProgressAnchorEl, setAmStreamInProgressAnchorEl] = useState(null);
    const amStreamInProgressPopoverOpen = Boolean(amStreamInProgressAnchorEl);
    const amStreamInProgressPopoverId = amStreamInProgressPopoverOpen ? 'simple-popover' : undefined;


    const handleAmStreamInProgressPopoverClick = (event) => {
        setAmStreamInProgressAnchorEl(event.currentTarget);
    };

    const handleAmStreamInProgressPopoverClose = () => {
        setAmStreamInProgressAnchorEl(null);
        // setExportAnchorEl(null);
    };

    const [createSerialNumberOpen, setCreateSerialNumberOpen] = useState(false);
    const createSerialNumberModal = {
        open: createSerialNumberOpen,
        setOpen: setCreateSerialNumberOpen
    }

    const [createRepackOrderOpen, setCreateRepackOrderOpen] = useState(false);
    const createRepackOrderModal = {
        open: createRepackOrderOpen,
        setOpen: setCreateRepackOrderOpen
    }

    const [printSnBarcodeOpen, setPrintSnBarcodeOpen] = useState(false);
    const [printSnBarcode, setPrintSnBarcode] = useState(null);
    const printSnBarcodeModal = {
        open: printSnBarcodeOpen,
        setOpen: setPrintSnBarcodeOpen
    }


    const handleCreateSerialNumberClose = (reload) => {
        setCreateSerialNumberOpen(false);
        if(reload) {

            preRegisterInbound({
                inboundId: props.incData.id,
                inboundLineId:inboundLineToEdit.inboundLine.id,
            }).unwrap()
            
            .then(res => {
                if(res["success"]){
                    
                    // setInboundLineToProcess(res);
                    setInboundLineToProcess({
                        ...res,
                        flags: {
                            ...res.flags,
                        }
                    });


                    setInBoundLineToEdit({
                        inboundLine:inboundLineToEdit.inboundLine,
                        inboundLineId:inboundLineToEdit.inboundLine.id,
                        dimensionsAndWeight: {
                            ...res.flags.dimensionAndWeightValues,
                            required: res.flags.enterDimensionsAndWeight,
                            hasBeenEditted: false,
                        },
                        lots: res.lots,
                        batches: res.batches,
                        repackingorders: res.repackingorders,
                        amounts:{
                            forecasted: res.inboundLine.amountForecasted,
                            moved: res.inboundLine.amountMoved,
                            received: res.inboundLine.amountReceived,
                            lastReceived: res.inboundLine.lastAmountReceived,
                            counted:'',
                        }
                    })
                } else {
                    props.setHighlightColor("red");
                }
            })
            .catch(err => {
                props.setHighlightColor("red");
            })
        }
    };

    const handleAddBatch = () => {
        if(createBatchLoading) return;
        if (!inboundLineToEdit) return;

        batchValidationSchema
        .validate(batchData, { abortEarly: false })
        .then(validData => {
            const obj = {
                amount: parseInt(batchData.amount),
                barcode: inboundLineToEdit.inboundLine.barcodes[0],
                inboundLineId: inboundLineToEdit.inboundLine.id,
                bbDate: batchData.bbDate,
                number: batchData.number,
            }

            createBatch(obj).unwrap().then(res => {
                const existingBatches = inboundLineToEdit.batches || [];
                const existingBatchIndex = existingBatches.findIndex(b => b.number === batchData.number);
                
                let updatedBatches;
                
                if (existingBatchIndex !== -1) {
                    const existingBatch = existingBatches[existingBatchIndex];
                    const updatedBatch = {
                        ...existingBatch,
                        amount: (parseInt(existingBatch.amount) || 0) + (parseInt(batchData.amount) || 0)
                    };
                
                    updatedBatches = [
                        ...existingBatches.slice(0, existingBatchIndex),
                        updatedBatch,
                        ...existingBatches.slice(existingBatchIndex + 1)
                    ];
                } else {
                    // Batch doesn't exist, add as new
                    updatedBatches = [...existingBatches, { ...res.object }];
                }
                
                const updatedLine = {
                    ...inboundLineToEdit,
                    batches: updatedBatches
                };
                

                setInBoundLineToEdit(updatedLine);

                setBatchData(initialBatchState);
                props.setHighlightColor("green");

                if(wasCounted){
                    inputRef.current.focus();
                } 

            }).catch(err => {
                showToastMessageRequestError(t('save_failed'), t, err);
                props.setHighlightColor("red");
            })
        })
        .catch(err => {
            //TODO:: Implement error handling
        });
    };

    const initialLotState = {
        amountReceived:'',
        bbDate:null,
        bbDateWasNotChanged:true,
        number:'',
    }
    const [lotData, setLotData] = useState(initialLotState);
    const lotValidationSchema = yup.object().shape({
        number: yup.string()
          .required('Number is required'),
        amountReceived: yup.number()
          .typeError('Amount must be a number')
          .required('Amount received is required')
          .positive('Amount must be greater than zero')
          .integer('Amount must be an integer'), // optional if decimals allowed
    });
    const handleAddLot = () => {
        if (!inboundLineToEdit) return;
        lotValidationSchema
        .validate(lotData, { abortEarly: false })
        .then(validData => {
            
            const obj = {
                amountReceived: parseInt(lotData.amountReceived),
                productBarcode: inboundLineToEdit.inboundLine.barcodes[0],
                inboundLineId: inboundLineToEdit.inboundLine.id,
                bbDate: lotData.bbDate,
                number: lotData.number,
            }

            createLot(obj).unwrap().then(res => {
                // proceed with validData
                const updatedLine = {
                    ...inboundLineToEdit,
                    lots: [
                        ...(inboundLineToEdit.lots || []),
                        { ...res.object } // Add a copy of lotData
                    ],
                };
                
                setInBoundLineToEdit(updatedLine);
                setLotData(initialLotState)
                props.setHighlightColor("green");

                if(wasCounted){
                    inputRef.current.focus();
                }

            }).catch(err => {
                showToastMessageRequestError(t('save_failed'), t, err);
                
                props.setHighlightColor("red");
            })
            
            
        })
        .catch(err => {
            // console.log(err.inner); // array of validation errors
        });
    };

    const initialPrintBarcodeState = {
        barcode: '',
        selectedWorkspace: props.selectedWorkSpace?.id,
        amount: '',
        name: '',
    }

    const [printBarcodeData, setPrintBarcodeData] = useState(initialPrintBarcodeState);
    const [nameFieldFlash, setNameFieldFlash] = useState(false);
    const printBarcodeValidationSchema = yup.object().shape({
        amount: yup.number()
          .typeError('Amount must be a number')
          .required('Amount received is required')
          .positive('Amount must be greater than zero')
          .integer('Amount must be an integer'), // optional if decimals allowed
    });

    const getBarcodeOptions = () => {
        if (!inboundLineToEdit) return [];
        
        const options = [];
        
        // Add product barcodes
        if (inboundLineToEdit.inboundLine?.barcodes && inboundLineToEdit.inboundLine.barcodes.length > 0) {
            inboundLineToEdit.inboundLine.barcodes.forEach((barcode, index) => {
                if (barcode) {
                    options.push({
                        value: barcode,
                        label: barcode,
                        type: 'barcode'
                    });
                }
            });
        }
        
        // Add SKU option if available (assuming it might be in the product data)
        if (inboundLineToEdit.inboundLine?.sku) {
            options.push({
                value: inboundLineToEdit.inboundLine.sku,
                label: `${t('sku')}: ${inboundLineToEdit.inboundLine.sku}`,
                type: 'sku'
            });
        }

        return options;
    };

    const handlePrintBarcode = () => {
        if (!inboundLineToEdit) return;
        printBarcodeValidationSchema
        .validate(printBarcodeData, { abortEarly: false })
        .then(validData => {
            
            const obj = {
                amount: parseInt(printBarcodeData.amount),
                barcode: (printBarcodeData.barcode || inboundLineToEdit.inboundLine.barcodes[0]),
                productId: inboundLineToEdit.inboundLine.productId,
                productName:printBarcodeData.name,
                workspaceId: printBarcodeData.selectedWorkspace,
            }

            printBarcode(obj).unwrap().then(res => {
                setPrintBarcodeData(initialPrintBarcodeState);
                props.setHighlightColor("green");

                if(wasCounted){
                    inputRef.current.focus();
                }

            }).catch(err => {
                showToastMessageRequestError(t('save_failed'), t, err);
                
                props.setHighlightColor("red");
            })
            
            
        })
        .catch(err => {
            console.log(err); // array of validation errors
        });
    };

    const handlePrintGenericBarcode = (barcode = null, amount = null, name = null) => {
        if (!inboundLineToEdit) return;
            
        const obj = {
            amount: amount ,
            barcode: barcode ,
            productId: inboundLineToEdit.inboundLine.productId,
            productName: name ?? printBarcodeData.name,
            workspaceId: printBarcodeData.selectedWorkspace,
        }

        printBarcode(obj).unwrap().then(res => {
            setPrintBarcodeData(initialPrintBarcodeState);
            props.setHighlightColor("green");

            if(wasCounted){
                inputRef.current.focus();
            }

        }).catch(err => {
            showToastMessageRequestError(t('save_failed'), t, err);
            
            props.setHighlightColor("red");
        })
        
            
    };


    const initialRepackOrderState = {
        barcode: '',
        inboundLineId: null,
        amount: '',
        colli: '',
    }

    const [repackOrderData, setRepackOrderData] = useState(initialRepackOrderState);
    const repackOrderValidationSchema = yup.object().shape({
        amount: yup.number()
            .typeError('Amount must be a number')
            .required('Amount received is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'), // optional if decimals allowed
        colli: yup.number()
            .typeError('Amount must be a number')
            .required('Amount received is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'), // optional if decimals allowed
    });

    const handleAddRepackOrder = () => {
        if(createRepackingOrderLoading) return;
        if (!inboundLineToEdit) return;

        repackOrderValidationSchema
        .validate(repackOrderData, { abortEarly: false })
        .then(validData => {
            
            const obj = {
                amount: parseInt(repackOrderData.amount),
                colli: parseInt(repackOrderData.colli),
                barcode: inboundLineToEdit.inboundLine.barcodes[0],
                inboundLineId: inboundLineToEdit.inboundLine.id,
            }

            createRepackingOrder(obj).unwrap().then(res => {
                setRepackOrderData(initialRepackOrderState);
                props.setHighlightColor("green");

                if(wasCounted){
                    inputRef.current.focus();
                }

            }).catch(err => {
                showToastMessageRequestError(t('save_failed'), t, err);
                
                props.setHighlightColor("red");
            })
            
        })
        .catch(err => {
            // console.log(err.inner); // array of validation errors
        });
    };

    const handleCount = (allReceived = false) => {
        if(!inboundLineToEdit) return;

        if(props.dimensionsAndWeightRequired || inboundLineToEdit.dimensionsAndWeight.hasBeenEditted) {
            processDimensionsAndWeight();
        } else {
            processCount(false,allReceived);
        }
    }

    const checkAmountCounted = () => {

        if(isNaN(inboundLineToEdit.amounts.counted)) return false;
        if(isNaN(parseInt(inboundLineToEdit.amounts.counted))) return false;
        if(parseInt(inboundLineToEdit.amounts.counted) <= 0) return false;

        return true;
    }


    const validateForProcessingCount = async (showErrors) => {
        if(isNaN(inboundLineToEdit.amounts.counted)) return false;
        if(isNaN(parseInt(inboundLineToEdit.amounts.counted))) return false;
        if(parseInt(inboundLineToEdit.amounts.counted) <= 0) return false;


        if(props.carrierRequired) {
            if(!inboundLineToProcess.flags.carrierId || inboundLineToProcess.flags.carrierId === -1) {
                if(showErrors){
                    toast.error(t("carrier_not_filled_in"), {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    props.setHighlightColor("red");
                }
                return false;  // Now this will stop execution of processCount
            }
        }
        if(props.dimensionsAndWeightRequired){
            try {
                await dimensionsAndWeightValidationSChema.validate(
                    inboundLineToEdit.dimensionsAndWeight,
                    { abortEarly: false }
                );
            } catch (err) {
                if(showErrors){
                    toast.error(t("dimensions_and_weight_not_filled_in"), {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    props.setHighlightColor("red");
                }
                return false;  // Now this will stop execution of processCount
            }
        }

        const batchSmallerThanShouldBe = checkBatchAmount();
        if(batchSmallerThanShouldBe){
            if(showErrors){
                toast.error(t("batches_insufficient_explanation"), {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                props.setHighlightColor("red");
            }
            return false;
        }

        const lotSmallerThanShouldBe = checkLotAmount();
        if(lotSmallerThanShouldBe){
            if(showErrors){
                toast.error(t("lot_insufficient_explanation"), {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                props.setHighlightColor("red");
            }
            return false;

        }

        const repackSmallerThanShouldBe = checkLotAmount();
        if(repackSmallerThanShouldBe){
            if(showErrors){
                toast.error(t("repacking_insufficient_explanation"), {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                props.setHighlightColor("red");
            }
            return false;

        }

        const serialNumbersMismatch = checkSerialNumberAmount();
        if (serialNumbersMismatch) {
            if (showErrors) {
                toast.error(t("serial_numbers_insufficient"), {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                props.setHighlightColor("red");
            }
            return false;
        }
        return true;
    }

    const processCount = async (surplus = false, allReceived = false) => {
        const valid = await validateForProcessingCount(true);

        if (!surplus && parseInt(inboundLineToEdit.amounts.counted) + parseInt(inboundLineToEdit.amounts.received ?? 0) > parseInt(inboundLineToEdit.inboundLine.amountForecasted)) {
            setConfirmModalOpen(true);
            return;
        }

        if(valid){
            const obj = {
                inboundlines: [
                    {
                        id: inboundLineToEdit.inboundLine.id,
                        amount: parseInt(inboundLineToEdit.amounts.counted),
                        ...(inboundLineToProcess.flags.carrierId !== null && { carrierId: inboundLineToProcess.flags.carrierId }),
                        surplus,
                        ...(allReceived && {allReceived: true}),
                        ...(createRepackOrder && {createRepackOrder:true})
                    }
                ]
            };

            // console.log(obj);
            countInbound(obj).unwrap().then(async res => {
                setInBoundLineToEdit(inboundLineToEdit => ({
                    ...inboundLineToEdit,
                    dimensionsAndWeight: {
                        ...inboundLineToEdit.dimensionsAndWeight,
                        hasBeenEditted: false,
                    },
                    amounts: {
                        ...inboundLineToEdit.amounts,
                        counted: '',
                    }
                }))
                props.setHighlightColor("green");
                props.getInbound(props.incData.id);

                await refetchJobAndLoad();

                setWasCounted(true);
                if(inputRef.current){
                    inputRef.current.focus();
                }
            }).catch(err => {
                showToastMessageRequestError(t('save_failed'), t, err);
                
                props.setHighlightColor("red");
            })
        }
    }

    const handleConfirm = () => {
        setConfirmModalOpen(false);
        processCount(true);
    }

    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const confirmModal = {
        open: confirmModalOpen,
        setOpen: setConfirmModalOpen,
        confirm: handleConfirm,
        data: {
            title: t("inboundline_received_exceeds_forecasted"),
            subtitle: t("inboundline_received_exceeds_forecasted_confirmation"),
            content: t("inboundline_received_exceeds_forecasted_content")
        }
    } 

    const isValidDimensionsAndWeight = () => {
        const fields = ['weight', 'length', 'width', 'height'];
    
        for (let field of fields) {
            const value = inboundLineToEdit.dimensionsAndWeight[field];
    
            if (value === undefined || value === null || value === '') {
                return false; // required
            }
    
            if (typeof value !== 'number' || isNaN(value)) {
                return false; // must be a number
            }
    
            if (value <= 0) {
                return false; // must be positive
            }
    
            if (!Number.isInteger(value)) {
                return false; // must be an integer
            }
        }
    
        return true;
    }

    const dimensionsAndWeightValidationSChema = yup.object().shape({
        weight: yup.number()
            .typeError('weight must be a number')
            .required('Amount weight is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'),
        length: yup.number()
            .typeError('length must be a number')
            .required('Amount length is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'),
        width: yup.number()
            .typeError('width must be a number')
            .required('Amount width is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'),
        height: yup.number()
            .typeError('height must be a number')
            .required('Amount height is required')
            .positive('Amount must be greater than zero')
            .integer('Amount must be an integer'),
    });

    const processDimensionsAndWeight = () => {
        dimensionsAndWeightValidationSChema
        .validate(inboundLineToEdit.dimensionsAndWeight, { abortEarly: false })
        .then(validData => {
            
            const obj = {
                weight: parseInt(inboundLineToEdit.dimensionsAndWeight.weight),
                length: parseInt(inboundLineToEdit.dimensionsAndWeight.length),
                width: parseInt(inboundLineToEdit.dimensionsAndWeight.width),
                height: parseInt(inboundLineToEdit.dimensionsAndWeight.height),
                id: inboundLineToEdit.inboundLine.productId,
                ...(inboundLineToProcess.flags.carrierId !== null && { carrierId: inboundLineToProcess.flags.carrierId }),
                productFieldValues: (inboundLineToProcess.flags.productFields || []).map(field => {
                    const fieldValue = (inboundLineToEdit.dimensionsAndWeight.productFieldValues || [])
                        .find(pf => pf.productfieldId === field.id);
                    return {
                        ...field,
                        value: fieldValue?.value ?? null,
                    };
                }),
            }

            updateProduct(obj).unwrap().then(async res => {
                if(inboundLineToEdit.amounts.counted ==='') {
                    props.setHighlightColor("green");
                    // setInboundLineToProcess(null);
                    // setInBoundLineToEdit(null);
                    props.getInbound(props.incData.id);

                    await refetchJobAndLoad();
                } else {
                    processCount();
                }
            }).catch(err => {
                toast.error(err.data.error, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                
                props.setHighlightColor("red");
            })
            
        })
        .catch(err => {
            toast.error(t("dimensions_and_weight_not_filled_in"), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            
            props.setHighlightColor("red");
            // console.log(err.inner); // array of validation errors
        });
    }

    const handleKeyDown = async (e) => {
        if (e.key === 'Enter') {
            let inboundLine = props.incData.inboundlines.find(line => line.barcodes.includes(e.target.value));
            if(typeof inboundLine === "undefined") {
                props.setHighlightColor("red");
                toast.error(t("cant_find_product_with_this_barcode"), {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                e.target.value = "";
                return;
            }
            preRegisterInbound({
                inboundId: props.incData.id,
                inboundLineId:inboundLine.id,
            }).unwrap()
            
            .then(res => {
                setWasCounted(false);
                if(res["success"]){
                    setSelectedCarrier(null);
                    // setInboundLineToProcess(res);
                    setInboundLineToProcess({
                        ...res,
                        flags: {
                            ...res.flags,
                        }
                    });

                    setInBoundLineToEdit({
                        inboundLine:inboundLine,
                        inboundLineId:inboundLine.id,
                        dimensionsAndWeight: {
                            ...res.flags.dimensionAndWeightValues,
                            required: res.flags.enterDimensionsAndWeight,
                            hasBeenEditted: false,
                        },
                        lots: res.lots,
                        batches: res.batches,
                        repackingorders: res.repackingorders,
                        amounts:{
                            forecasted: res.inboundLine.amountForecasted,
                            moved: res.inboundLine.amountMoved,
                            received: res.inboundLine.amountReceived,
                            lastReceived: res.inboundLine.lastAmountReceived,
                            counted:'',
                        }
                    })
                    if(countRef.current){
                        countRef.current.focus();
                    }
                } else {
                    props.setHighlightColor("red");
                }
            })
            .catch(err => {
                props.setHighlightColor("red");
            })
            e.target.value = "";
        }
    }


    const handleSerialnumber = async (e) => {
        if (e.key === 'Enter') {
            if(receiveSerialNumberLoading) return;

            const inputValue = e.target.value;
            const serialNumber = inboundLineToProcess.serialnumbers
                .find(item => item.barcode.includes(inputValue));

            if(serialNumber){
                if(serialNumber.state !== general_states.CONCEPT) {
                    props.setHighlightColor("orange");

                    if(serialNumberRef.current) {
                        serialNumberRef.current.focus();
                    }
                    e.target.value = "";
                    return;
                }
                receiveSnFunction(serialNumber.barcode, false);
            } else {
                props.setHighlightColor("orange");
            }

            if(serialNumberRef.current) {
                serialNumberRef.current.focus();
            }
            e.target.value = "";
        }
    }

    const [addSnModalOpen, setAddSnModalOpen] = useState(false);

    const handleConfirmReceiveSn =  (barcodes) => {
        addSnModal.setOpen(false);
        receiveSnFunction(barcodes, true);
    }

    const addSnModal = {
        open: addSnModalOpen,
        setOpen: setAddSnModalOpen,
        confirm: handleConfirmReceiveSn
    }

    const receiveSnFunction = async (barcode, toAdd) => {
        try {
            const res = await receiveSerialNumber({
                id: props.incData.id,
                lineId: inboundLineToEdit.inboundLineId,
                serialnumbers: toAdd ? barcode : [barcode],
            }).unwrap();

            props.setHighlightColor("green");

            setInboundLineToProcess(prev => {
            let updated = [...prev.serialnumbers];

            if (toAdd) {
                if (res.created?.length) {
                    res.created.forEach(sn => {
                        if (!updated.some(existing => existing.barcode === sn.barcode)) {
                            updated.push({
                                ...sn,
                                state: general_states.RECEIVED,
                            });
                        }
                    });
                }
            } else {
                updated = updated.map(sn =>
                sn.barcode === barcode
                    ? { ...sn, state: general_states.RECEIVED }
                    : sn
                );
            }

            // 🔀 sort once
            const order = {
                [general_states.CONCEPT]: 1,
                [general_states.RECEIVED]: 2,
                [general_states.COMPLETED]: 3,
            };

            updated.sort((a, b) => order[a.state] - order[b.state]);

            return {
                ...prev,
                serialnumbers: updated,
            };
            });
        } catch (err) {
            console.error(err);
            props.setHighlightColor("red");
        }
    };


    // const receiveSnFunction = async (barcode, toAdd) => {
    //     await receiveSerialNumber({
    //         id:props.incData.id,
    //         lineId:inboundLineToEdit.inboundLineId,
    //         serialnumbers:[barcode],
    //     }).unwrap()
    //     .then(res => {
    //         props.setHighlightColor("green");
    //         setInboundLineToProcess(prev => {
    //             let updated;

    //             if (toAdd) {
    //                 updated = [
    //                     ...prev.serialnumbers,
    //                     {
    //                         ...res.serialnumber,
    //                         state: general_states.RECEIVED,
    //                     },
    //                 ];
    //             } else {
    //                 updated = prev.serialnumbers.map(sn =>
    //                 sn.barcode === barcode
    //                     ? { ...sn, state: general_states.RECEIVED }
    //                     : sn
    //                 );
    //             }

    //             const order = {
    //                 [general_states.CONCEPT]: 1,
    //                 [general_states.RECEIVED]: 2,
    //                 [general_states.COMPLETED]: 3,
    //             };

    //             const sorted = [...updated].sort(
    //                 (a, b) => order[a.state] - order[b.state]
    //             );

    //             return {
    //                 ...prev,
    //                 serialnumbers: sorted,
    //             };
    //         });
    //     }).catch(err => {
    //         console.log(err);
    //         props.setHighlightColor("red");

    //     })
    // }

    const handleInboundLineOnClick = async (inboundLine) => {
        if(preRegisterLoading) return;

        preRegisterInbound({
            inboundId: props.incData.id,
            inboundLineId:inboundLine.id,
        }).unwrap()
        
        .then(res => {
            setWasCounted(false);
            if(res["success"]){
                setSelectedCarrier(null);
                setInboundLineToProcess({
                    ...res,
                    flags: {
                        ...res.flags,
                    }
                });

                setInBoundLineToEdit({
                    inboundLine:inboundLine,
                    inboundLineId:inboundLine.id,
                    dimensionsAndWeight: {
                        ...res.flags.dimensionAndWeightValues,
                        required: res.flags.enterDimensionsAndWeight,
                        hasBeenEditted: false,
                    },
                    lots: res.lots,
                    batches: res.batches,
                    repackingorders: res.repackingorders,
                    amounts:{
                        forecasted: res.inboundLine.amountForecasted,
                        moved: res.inboundLine.amountMoved,
                        received: res.inboundLine.amountReceived,
                        lastReceived: res.inboundLine.lastAmountReceived,
                        counted:'',
                    }
                })
                if(countRef.current){
                    countRef.current.focus();
                }
            } else {
                props.setHighlightColor("red");
            }
        })
        .catch(err => {
            props.setHighlightColor("red");
        })
    }

    const getCarrierById = (carrierId) => {
        getCarrier(carrierId)
        .unwrap()
        .then(res => {
            setSelectedCarrier({
                id: res.id,
                name: res.name,
                type: res.type,
            })
        })
        .catch(err => {
            console.error("err",err);

        })
    }

    useEffect(() => {
        if(inboundLineToProcess?.flags && inboundLineToProcess.flags?.carrierId !== null) {
            getCarrierById(inboundLineToProcess.flags.carrierId);
        }
    }, [inboundLineToProcess?.flags,inboundLineToProcess?.flags?.carrierId])

    const checkBatchAmount = () => {
        if(!inboundLineToProcess) return false;
        if(!inboundLineToProcess.flags.batchRequired) return false;

        const totalAmount = inboundLineToEdit.batches.reduce((total, batch) => {
            const amount = parseInt(batch.amount);
            return !isNaN(amount) ? total + amount : total;
        }, 0);


        let counted = isNaN(parseInt(inboundLineToEdit.amounts.counted)) ? 0 : parseInt(inboundLineToEdit.amounts.counted);
        let received = isNaN(parseInt(inboundLineToEdit.amounts.received)) ? 0 : parseInt(inboundLineToEdit.amounts.received);
        return totalAmount < (counted + received);
    }

    const checkLotAmount = () => {
        if(!inboundLineToProcess) return false;
        if(!inboundLineToProcess.flags.lotRequired) return false;
        const totalAmount = inboundLineToEdit.lots.reduce((total, lot) => {
            const amount = parseInt(lot.amountReceived);
            return !isNaN(amount) ? total + amount : total;
        }, 0);
          
        let counted = isNaN(parseInt(inboundLineToEdit.amounts.counted)) ? 0 : parseInt(inboundLineToEdit.amounts.counted);
        let received = isNaN(parseInt(inboundLineToEdit.amounts.received)) ? 0 : parseInt(inboundLineToEdit.amounts.received);
        return totalAmount < (counted + received);
    }

    const checkSerialNumberAmount = () => {
        if (!inboundLineToProcess) return false;
        if (!inboundLineToProcess.flags.serialNumberRequired) return false;

        const receivedSerialsCount = inboundLineToProcess.serialnumbers?.filter(sn => sn.state === general_states.RECEIVED).length || 0;

        let counted = isNaN(parseInt(inboundLineToEdit.amounts.counted)) ? 0 : parseInt(inboundLineToEdit.amounts.counted);
        let received = isNaN(parseInt(inboundLineToEdit.amounts.received)) ? 0 : parseInt(inboundLineToEdit.amounts.received);

        return receivedSerialsCount !== (counted + received);
    };

    const getRepackTotal = () => {
        if(!inboundLineToEdit) return false;
        const totalAmount = inboundLineToEdit.repackingorders?.reduce((total, repackorder) => {
            if (repackorder.amount && typeof repackorder.amount === 'number') {
                return total + repackorder.amount;
            }
            return total;
        }, 0);
        return totalAmount ?? 0;

    }
    const checkRepackAmount = () => {
        if(!inboundLineToProcess) return false;
        if(!inboundLineToProcess.flags.repackingRequired) return false;
        const totalAmount = getRepackTotal();
          
        let counted = isNaN(parseInt(inboundLineToEdit.amounts.counted)) ? 0 : parseInt(inboundLineToEdit.amounts.counted);
        let received = isNaN(parseInt(inboundLineToEdit.amounts.received)) ? 0 : parseInt(inboundLineToEdit.amounts.received);
        return totalAmount < (counted + received);
    }

    const repackLeftToDo = () => {
        if(!inboundLineToProcess) return 0;
        if(!inboundLineToProcess.flags.repackingRequired) return 0;
        const totalAmount = getRepackTotal();
          
        let counted = isNaN(parseInt(inboundLineToEdit.amounts.counted)) ? 0 : parseInt(inboundLineToEdit.amounts.counted);
        let received = isNaN(parseInt(inboundLineToEdit.amounts.received)) ? 0 : parseInt(inboundLineToEdit.amounts.received);
        return (counted + received) - totalAmount;

    }

    const popperShouldAppear = () => {
        if(!inboundLineToEdit) return false;

        return checkLotAmount() || checkBatchAmount() || checkRepackAmount();
    }

    const getPaddingBottom = () => {
        const checks = [
            checkLotAmount(),
            checkBatchAmount(),
            checkRepackAmount(),
        ];
    
        const trueCount = checks.filter(Boolean).length;
    
        if (trueCount === 0) return "16px";
    
        const basePadding = 192;
        const additionalPadding = 125;
    
        const totalPadding = basePadding + (trueCount - 1) * additionalPadding;
    
        return `${totalPadding}px`;
    };

    
    const doHover = async () => {
        if(!isHovered && !wasChecked) {
            setIsHovered(true)
            setAnchorEl(buttonRef.current);

            const result = await validateForProcessingCount(false);
            if(!result) {
                setShouldBeShown(true);
            } else {
                setShouldBeShown(false);
            }

        }
        setWasChecked(true);
    }

    const doUnhover = () => {
        setWasChecked(false);
        setShouldBeShown(false);
        setIsHovered(false)
        setAnchorEl(null)
    }

    const [isValidForProcessing, setIsValidForProcessing] = useState(true);
    const [isValidForProcessingAndFinish, setIsValidForProcessingAndFinish] = useState(true);
    // const [wasSetOnce, setWasSetOnce] = useState(false);

    useEffect(() => {
        if(!inboundLineToEdit) return;

        const check = async () => {
            const isValid = await validateForProcessingCount(false);
            setIsValidForProcessing(isValid);

            const counted = isNaN(parseInt(inboundLineToEdit.amounts.counted)) ? 0 : parseInt(inboundLineToEdit.amounts.counted);
            const received = isNaN(parseInt(inboundLineToEdit.amounts.received)) ? 0 : parseInt(inboundLineToEdit.amounts.received);

            // number of serials in RECEIVED state
            const receivedSerialsCount = inboundLineToProcess.serialnumbers?.filter(sn => sn.state === general_states.RECEIVED).length || 0;

            // mismatch if serial numbers don't match counted + received
            const mismatchSn = receivedSerialsCount !== (counted + received);

            // Now valid if counted > 0 AND serial numbers match
            const isValidAndFinish = counted > 0 && !mismatchSn;
            setIsValidForProcessingAndFinish(isValidAndFinish);

            const productName = inboundLineToEdit.inboundLine.description || '';
            // Limit product name to reasonable length for barcode printing
            const truncatedName = productName.length > 23 ? productName.substring(0, 23) + '...' : productName;
            
            setPrintBarcodeData(prevState => ({
                ...prevState,
                name: truncatedName,
                productId: inboundLineToEdit.inboundLine.productId,
                barcode: inboundLineToEdit.inboundLine.barcodes?.[0] || ''
            }));

        };
        check();
    }, [inboundLineToEdit,inboundLineToProcess]);

    // useEffect(() => {
    //     if(wasChecked){
    //         const check = async () => {
    //             const isValid = await validateForProcessingCount(false);
    //             setIsValidForProcessing(isValid);
    //         };
    //         check();
    //     }
    // }, [wasChecked]);

    const [updateStockModalOpen, setUpdateStockModalOpen] = useState(false);
    const updateStockModal = {
        open: updateStockModalOpen,
        setOpen: setUpdateStockModalOpen
    }

    const handleUpdateStockClose = (data) => {
        setUpdateStockModalOpen(false);
        if(data) {
            setInBoundLineToEdit(prevState => ({
                ...prevState,
                lots: prevState.lots.map(lot =>
                    lot.id === data.id ? { ...lot, ...data } : lot
                ),
            }));
        }
    };

    const [addInboundLineModalOpen, setAddInboundLineModalOpen] = useState(false);
    const addInboundLineModal = {
        open: addInboundLineModalOpen,
        setOpen: setAddInboundLineModalOpen
    }

    const handleAddInboundLineClose = () => {
        setAddInboundLineModalOpen(false);
        props.getInbound(props.incData.id);
    }

    const [batchModalOpen, setBatchModalOpen] = useState(false);
    const updateBatchModal = {
        open: batchModalOpen,
        setOpen: setBatchModalOpen
    }

    const handleUpdateBatchClose = (data) => {
        setBatchModalOpen(false);
        if(data) {
            setInBoundLineToEdit(prevState => ({
                ...prevState,
                batches: prevState.batches.map(lot =>
                     lot.id === data.id ? { ...lot, ...data } : lot
                ),
            }));
        }
    };

    const [lotToDelete, setLotToDelete] = useState(null);

    const [deleteLotOpen, setDeleteLotOpen] = useState(false);
    const [deleteLot] = useDeleteLotMutation();
    const confirmDeleteLot = async () => {
        try {
             deleteLot({id: lotToDelete.id})
            .unwrap()
            .then(res => {

                toast.success(res.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                setInBoundLineToEdit(prevState => ({
                    ...prevState,
                    lots: prevState.lots.filter(lot => lot.id !== lotToDelete.id),
                }));
                setLotToDelete(null);

            }).catch(err => {
                showToastMessageDeleteRequest(t, {success: false, error: err.error});

            })
        } catch (err) {
            showToastMessageDeleteRequest(t, {success: false, error: err.error});
        }
    };


    const confirmDeleteLotLotModal = {
        open: deleteLotOpen,
        setOpen: setDeleteLotOpen,
        confirm: confirmDeleteLot
    }


    const [batchToDelete, setBatchToDelete] = useState(null);

    const [deleteBatchOpen, setDeleteBatchOpen] = useState(false);
    const [deleteBatch] = useDeleteBatchMutation();
    const confirmDeleteBatch = async () => {
        try {
            deleteBatch({id: batchToDelete.id, inboundLineId: inboundLineToEdit?.inboundLine?.id})
            .unwrap()
            .then(res => {
                toast.success(res.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                setInBoundLineToEdit(prevState => ({
                    ...prevState,
                    batches: prevState.batches.filter(batch => batch.id !== batchToDelete.id),
                }));
                setBatchToDelete(null);

            }).catch(err => {
                showToastMessageDeleteRequest(t, {success: false, error: err.data.error});

            })
        } catch (err) {
            showToastMessageDeleteRequest(t, {success: false, error: err.error});
        }
    };


    const confirmDeleteBatchModal = {
        open: deleteBatchOpen,
        setOpen: setDeleteBatchOpen,
        confirm: confirmDeleteBatch
    }

    const [completeInboundOpen, setCompleteInboundOpen] = useState(false);
    const [linkCostOpen, setLinkCostOpen] = useState(false);
    const [printAllBarcodesOpen, setPrintAllBarcodesOpen] = useState(false);
    const [completeInbound, {isLoading: completeInboundLoading}] = useCompleteInboundMutation();

    const confirmCompleteInbound = async () => {
        try {
            if (completeInboundLoading) return;

            const response = await completeInbound(props.incData.id).unwrap();

            showToastMessageUpdateRequest(t, response);
            
            // Reload inbound
            props.getInbound(props.incData.id);

            preRegisterInbound({
                inboundId: props.incData.id,
            }).unwrap()
            
            .then(res => {
                if(res["success"]){
                    
                    // setInboundLineToProcess(res);
                    setInboundLineToProcess({
                        ...res,
                        flags: {
                            ...res.flags,
                        }
                    });
                    

                    setInBoundLineToEdit({
                        inboundLine:inboundLineToEdit.inboundLine,
                        inboundLineId:inboundLineToEdit.inboundLine.id,
                        dimensionsAndWeight: {
                            ...res.flags.dimensionAndWeightValues,
                            required: res.flags.enterDimensionsAndWeight,
                            hasBeenEditted: false,
                        },
                        lots: res.lots,
                        batches: res.batches,
                        repackingorders: res.repackingorders,
                        amounts:{
                            forecasted: res.inboundLine.amountForecasted,
                            moved: res.inboundLine.amountMoved,
                            received: res.inboundLine.amountReceived,
                            lastReceived: res.inboundLine.lastAmountReceived,
                            counted:'',
                        }
                    })
                } else {
                    props.setHighlightColor("red");
                }
            })
            .catch(err => {
                props.setHighlightColor("red");
            })

            setWasCounted(true);
            if(inputRef.current){
                inputRef.current.focus();
            }
        } catch (err) {
            // console.log("err",err);
            showToastMessageRequestError(t('update_failed'), t, err);
        }
    };

    const completeInboundModal = {
        open: completeInboundOpen,
        setOpen: setCompleteInboundOpen,
        confirm: confirmCompleteInbound,
        data: {
            title: t("complete_inbound"),
            // subtitle: "",
            content: t("complete_inbound_content")
        }
    } 

    const linkCostModal = {
        open: linkCostOpen,
        setOpen: setLinkCostOpen,
    } 

    const printAllBarcodesModal = {
        open: printAllBarcodesOpen,
        setOpen: setPrintAllBarcodesOpen,
    }

    const refetchJobAndLoad = async () => {
        preRegisterInbound({
            inboundId: props.incData.id,
            inboundLineId:inboundLineToEdit.inboundLine.id,
        }).unwrap()
        
        .then(res => {
            if(res["success"]){
                
                // setInboundLineToProcess(res);
                setInboundLineToProcess({
                    ...res,
                    flags: {
                        ...res.flags,
                    }
                });


                setInBoundLineToEdit({
                    inboundLine:inboundLineToEdit.inboundLine,
                    inboundLineId:inboundLineToEdit.inboundLine.id,
                    dimensionsAndWeight: {
                        ...res.flags.dimensionAndWeightValues,
                        required: res.flags.enterDimensionsAndWeight,
                        hasBeenEditted: false,
                    },
                    lots: res.lots,
                    batches: res.batches,
                    repackingorders: res.repackingorders,
                    amounts:{
                        forecasted: res.inboundLine.amountForecasted,
                        moved: res.inboundLine.amountMoved,
                        received: res.inboundLine.amountReceived,
                        lastReceived: res.inboundLine.lastAmountReceived,
                        counted:'',
                    }
                })
            } else {
                props.setHighlightColor("red");
            }
        })
        .catch(err => {
            props.setHighlightColor("red");
        })
    }

    const showAddButton = inboundLineToProcess?.flags.serialNumberRequired && inboundLineToEdit?.amounts.forecasted > inboundLineToEdit?.amounts.received
        ? inboundLineToProcess?.serialnumbers?.length < inboundLineToEdit?.amounts.forecasted
        : true;

    return(
        <Box
            sx={{
                flex:1,
                marginBottom:3,
                position:"relative",
                display:"flex",
                overflow:"hidden",
                "@media screen and (max-width: 1080px)" : {
                    flexDirection:'column'
                }
            }}
        >
            <Box 
                sx={{
                    flexShrink:0,
                    width:492,
                    overflow:"auto",
                    "@media screen and (max-width: 1080px)" : {
                        display:'flex'
                    }
                }}
            >
                <ButtonBase
                    onClick={() => {
                        // if(inboundLineToProcess !== null) {
                        //     setInboundLineToProcess(null);
                        // }  else {
                            props.setShowInboundToProcess(false);
                        // }
                    }}
                    sx={{
                        ml:"-16px",
                        fontWeight:"bold",
                        p:2,
                        color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]
                    }}
                >
                    {t("close")}
                    {/* {inboundLineToProcess !== null ? t("go_back") : t("close")} */}
                </ButtonBase>

                <Box
                    sx={{
                        display:"flex",
                        flexShrink:0,
                        // overflow:"hidden",
                    }}
                >
                    <Box
                        sx={{
                            mt:1,
                            flex:1,
                            width:370,
                            "@media screen and (max-width: 1366px)" : {
                                width:300,
                            }
                        }}
                    >
                       
                        <Box
                            sx={{
                                display:"flex",
                                justifyContent:"space-between",
                                mb:props.incData.relationRemark ? 2.5 :4,
                            }}
                        >
                            <Box>
                                <Box
                                    sx={{
                                        display:"flex",
                                        gap:0.75,
                                    }}
                                >
                                    <Heading color={theme.palette.mode === "dark" ? colors.purple[400] : colors.purple[400]}>{t("inbound")}</Heading>
                                    <Heading>{props.incData.barcode}</Heading>
                                </Box>
                                <Box>
                                    <Text>
                                        {props.incData.relation} ({props.incData.reference})
                                    </Text>
                                </Box>
                                <Text light>{new Date(props.incData.date).toLocaleDateString(i18n.language)}</Text>
                                
                            </Box>
                            <Box
                                sx={{
                                }}
                            >
                                <Box
                                    sx={{
                                        pb:1,
                                        "@media screen and (max-width: 47.9375em)" : {
                                            display:"none"
                                        }
                                    }}
                                >
                                    <ButtonBase
                                        onClick={handleFilterPopoverClick}
                                        sx={{
                                            width:40,
                                            height:40,
                                            flexShrink:0,
                                            display:"flex",
                                            alignItems:'center',
                                            justifyContent:"center",
                                            color:colors.txt["primary"],
                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                            border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                            boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                            borderRadius:5,
                                            gap:2,
                                            "&.active": {
                                                background:theme.palette.mode === "dark" ? colors.orange[100] : colors.orange[100],
                                            }
                                        }}
                                    >
                                        <MoreVertIcon/>
                                    </ButtonBase>
                                    {/* <Shbutton
                                        // onClick={handleFilterPopoverClick}
                                        className={"group-btn"}
                                        // onClick={props.action}
                                        color={"primaryGrey"}
                                        variant="contained"
                                    >
                                        {t('actions')}
                                    </Shbutton> */}
                                    <AMInboundProcessing
                                        open={filterPopoverOpen}
                                        anchorEl={filterAnchorEl}
                                        onClose={handleFilterPopoverClose}
                                        completeInboundModal={completeInboundModal}
                                        linkCostModal={linkCostModal}
                                        printAllBarcodesModal={bulkBarcodePrintEnabled ? printAllBarcodesModal : null}
                                        invoiceId={props.incData?.invoiceId}
                                    />
                                    {/* <AMOrderSpWarehouses
                                        id={filterPopoverId}
                                        open={filterPopoverOpen}
                                        anchorEl={filterAnchorEl}
                                        onClose={handleFilterPopoverClose}

                                        addModal={addModal}
                                        returnModal={returnModal}
                                        confirmDuplicateModal={confirmDuplicateModal}
                                        shipmentModal={shipmentModal}
                                        orderData={orderData}
                                    
                                    /> */}

                                </Box>
                            </Box>
                       </Box>
                     
                        {props.incData.relationRemark &&
                            <Box
                                sx={{
                                    mb:3,
                                    p:1.5,
                                    py:1,
                                    borderRadius:2,
                                    background: colors.orange[100],
                                    display:"flex",
                                    width:1,
                                    gap:1,
                                    flexDirection:"column"
                                }}
                            >
                                <Text bold>{t("remark")}</Text>
                                <Text>{props.incData.relationRemark}</Text>
                            </Box>
                        }

                        <Box display="flex"
                            height="32px"
                            borderRadius="20px"
                            sx={{
                                background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                mb:2,
                            }}
                        >
                            <InputBase
                                sx={{
                                    mx: 2,
                                    flex:1,
                                }}
                                placeholder={t("search_on_sku")}
                                value={skuSearch}
                                onChange={(e) => setSkuSearch(e.target.value)}
                            />
                        </Box>

                        <Box
                            sx={{
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:'center',
                            }}
                        >
                            <Heading>
                                {t("to_process")}

                            </Heading>

                            <Shbutton
                                onClick={() => addInboundLineModal.setOpen(true)}
                                size={"32"}
                                variant="contained"
                                color={theme.palette.mode === "dark" ? "primaryGrey" : 'grey'}
                            >
                                {t("new_inboundline")}
                            </Shbutton>
                        </Box>
                        {inboundLineToEdit !== null &&
                            <Box
                                sx={{
                                    mt:2,
                                    flex: 1,
                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                    border:`1px solid ${colors.grey[100]}`,
                                    borderRadius: 4,
                                    // marginTop: 3,
                                    paddingTop:4,
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                    paddingBottom: 3,
                                    justifyContent: 'center',  // To center contents vertically
                                    alignItems: 'center',      // To center contents horizontally
                                }}
                            >
                                <Subheading>{t("scan_next_product")}</Subheading>
                                <img 
                                    src="/img/barcode.svg" 
                                    alt="Barcode" 
                                    style={{
                                        marginTop:"16px",
                                        width: '30%', 
                                        height: '30%', 
                                        objectFit: 'contain',
                                        animation: 'pulsate 1.5s infinite',
                                        marginBottom:"16px",
                                    }} 
                                />

                                <Box display="flex"
                                    height="32px"
                                    // maxWidth="400px"
                                    borderRadius="20px"
                                    backgroundColor={colors.grey[100]}
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                        marginTop:0.5,
                                        marginBottom:0.5,
                                        justifyContent:"space-between",
                                        "@media screen and (max-width: 47.9375em)" : {
                                            flexDirection:"column"
                                        }
                                    }}
                                >
                                    <InputBase 
                                        inputRef={inputRef}
                                        sx={{
                                            ml: 2, 
                                            flex:1, 
                                            width: 248, 
                                            textAlign: 'center', 
                                            justifyContent: 'center'
                                        }} 
                                        placeholder={t("scan_type_barcode")}
                                        onKeyDown={handleKeyDown}
                                        autoFocus={wasCounted}
                                    />
                                </Box>
                            </Box>
                        }


                        {visibleInboundLines.map((line,index) => {
                            const stateColor = getInboundLineStateColor(line.state);
                            return (
                            <ButtonBase
                                disabled={preRegisterLoading}
                                onClick={() => handleInboundLineOnClick(line)}
                                key={"inclines"+line.id}
                                className={cx('', {
                                    'active' : line.id === inboundLineToEdit?.inboundLine?.id,
                                })}
                                sx={{
                                    width:370,
                                    mt:1.5,
                                    flex:1,
                                    display:"flex",
                                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                    border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                    boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                    borderRadius:3,
                                    px:2,
                                    py:2,
                                    gap:2,
                                    alignItems:"flex-start",
                                    justifyContent:"space-between",
                                    ...(stateColor && {
                                        background:stateColor[100],
                                    }),
                                    "&.active": {
                                        background:colors.primary[100],
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        textAlign:'left'
                                        // display:'flex',
                                        // justifyContent:"flex-start"
                                    }}
                                >
                                    <Text bold>
                                        {line.description}
                                    </Text><br/>
                                    <Text sx={{pt:2,}}>
                                    {line.barcodes.join(", ")}
                                    </Text>
                                </Box>

                                <Box
                                    className={cx('', {
                                        'active' : line.id === inboundLineToEdit?.inboundLine?.id,
                                    })}
                                    sx={{
                                        flexShrink:0,
                                        px:2,
                                        height:32,
                                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                        lineHeight:"32px",
                                        fontSize:14,
                                        fontFamily:"Roboto, sans-serif",
                                        borderRadius:4,
                                        color:colors.txt["primary"],
                                        ...(stateColor && {
                                            background:stateColor[100],
                                            color:stateColor[400],
                                        }),
                                        "&.active": {
                                            background:colors.primary[100],
                                            color:colors.primary[400],
                                        }
                                    }}
                                >
                                    <b>{line.amountReceived}</b> / {line.amountForecasted}
                                </Box>

                            </ButtonBase>
                            );
                        })}
                        
                        {/* <Box sx={{mt:2}}>
                            <Shbutton block className={"group-btn"} color={theme.palette.mode === "dark" ? "primaryGreyOpposite" : "grey"} 
                            onClick={() => completeInboundModal.setOpen(true)} variant="contained">{t('complete')}</Shbutton>
                        </Box> */}
                    </Box>

                    <Box
                        width={120}
                        sx={{
                            display: "flex",
                            paddingBottom: 3,
                            justifyContent: "center",
                            alignItems: "center",
                            color: colors.grey[300],
                            position: "relative", // For controlling the layout and positioning
                            "@media screen and (max-width: 1080px)": {
                                transform: "rotate(90deg)",
                                width: 380,
                            },
                        }}
                    >
                        {/* Wrapper Box for animation */}
                        <Box
                            sx={{
                                overflow:"hidden",
                                width: "100%",
                                // height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                // animation: "moveArrow 1.5s infinite ease-in-out", // Animation applied to wrapper box
                                // "@keyframes moveArrow": {
                                //     "0%": {
                                //     transform: "translateX(0)", // Start position
                                //     },
                                //     "50%": {
                                //     transform: "translateX(15%)", // Move to the right (adjust as needed)
                                //     },
                                //     "100%": {
                                //     transform: "translateX(0)", // Return to the start
                                //     }
                                // },
                            }}
                        >
                            <img
                                className="supra-arrow"  // Keep the class for potential future use
                                src="/img/arrow.svg"
                                alt="Barcode"
                                style={{
                                    width: "40%",   // Image size
                                    height: "40%",  // Image size
                                    objectFit: "contain", // Ensures the image fits the container
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
                           

              
            </Box>
            
            <Box
                sx={{
                    overflow:"hidden",
                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],

                    flex:1,
                    p:2,
                    borderRadius:6,
                    // borderTopLeftRadius:24,
                    // borderTopRightRadius:24,
                    flexDirection: "column",
                    display:"flex",
                }}
            >
                 {inboundLineToEdit !== null ?
                    <Box
                        sx={{
                            flex:1,
                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                            p:2,
                            borderRadius:4,
                            overflow:"auto",
                            pb: getPaddingBottom()
                        }}
                    >
                        <Box
                            sx={{
                                width:1,
                                display:"flex",
                                alignItems:'flex-start',
                                justifyContent:"space-between",
                                gap:3,
                            }}
                        >
                            <Box
                                onClick={() => {
                                    if(!spProductLoading) {
                                        setSpProductLoading(true);
                                    } 
                                    setProductsSpIsExtended(true);
                                }}
                                sx={{
                                    overflow:"hidden",
                                    cursor:"pointer",
                                    width:1,
                                }}
                            >
                                <Heading>
                                    {inboundLineToEdit.inboundLine.description}
                                    <OpenInNewIcon
                                        sx={{
                                            ml:1,
                                        }}    
                                    />
                                </Heading>
                                <Text sx={{pt:1}}>{inboundLineToEdit.inboundLine.barcodes.join(", ")}</Text>
                                {inboundLineToEdit.inboundLine?.inboundInstruction?.trim() && (
                                    <Box
                                        sx={{
                                            mt:1.5,
                                            flex: 1,
                                            background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[50],
                                            p: 1.5,
                                            display: "flex",
                                            flexDirection: "column",
                                            borderRadius: 4,
                                        }}
                                    >
                                        <Text>{t("inbound_instruction")}</Text>
                                        <Text bold>{inboundLineToEdit.inboundLine.inboundInstruction}</Text>
                                    </Box>
                                )}
                            </Box>

                        </Box>
                        <Box
                            sx={{
                                mt:1.5,
                                display:"flex",
                                alignItems:'flex-start',
                                gap:3,

                            }}
                        >
                            <Box
                                sx={{
                                    flex:1,
                                    display:'flex',
                                    flexDirection:'column',
                                }}
                            >
                                {!wasCounted ?
                                    <Box
                                        sx={{
                                            flex:1,
                                            background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                            borderRadius:4,
                                            p:3,

                                        }}
                                    >
                                        <Subheading>{t("count")}</Subheading>
                                    
                                        <Box
                                            className={cx('', {
                                                'required-not-filled':  (inboundLineToEdit.amounts.counted === '' || !(/^[1-9]\d*$/.test(inboundLineToEdit.amounts.counted))) 
                                            })}
                                            
                                            sx={{
                                                background: colors.green[100],
                                                border: `1px solid ${colors.green[400]}`,
                                                display:"flex",
                                                mt:1,
                                                alignItems:'center',
                                                borderRadius:4,
                                                overflow:'hidden',
                                                px:0.5,
                                                "&.required-not-filled" : {
                                                    border: `1px solid ${colors.red[400]}`,
                                                    background: colors.red[100]
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    textAlign:"center"
                                                }}
                                            >

                                                <Text>{t("amount")}</Text>
                                            </Box>
                                            <InputBase
                                                inputRef={countRef}
                                                autoFocus={!wasCounted}
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    if (/^\d*$/.test(input)) {
                                                        if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                            setInBoundLineToEdit((prev) => ({
                                                                ...prev,
                                                                amounts: {
                                                                    ...prev?.amounts,
                                                                    counted: input,
                                                                },
                                                            }));
                                                        }
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleCount(false);
                                                    }

                                                }}
                                                value={inboundLineToEdit.amounts.counted}
                                                sx={{
                                                    width:1,
                                                    height:32,
                                                    px:1.5,

                                                }}
                                            />

                                        </Box>

                                        {/* <ButtonBase 
                                            onClick={handleCount}
                                            ref={buttonRef}
                                            className={cx('', {
                                                'disabled': !isValidForProcessing,
                                            })}
                                            onMouseEnter={doHover}
                                            onMouseLeave={doUnhover}
                                            sx={{
                                                width:1,
                                                height:32,
                                                px:2,
                                                background:themeSettings(theme.palette.mode).palette.primary.main,
                                                color: themeSettings(theme.palette.mode).palette.primary.contrastText,
                                                borderRadius:4,
                                                fontSize:14,
                                                fontWeight:"bold",
                                                "&.disabled" : {
                                                    opacity:0.55,
                                                    userSelect:"none",
                                                    "&:hover" : {
                                                        cursor: "default"
                                                    }
                                                }
                                            }}
                                        >
                                                {t("count")}
                                        </ButtonBase> */}
                                    

                                        <Box
                                            sx={{
                                                mt:1,
                                                mb:2,
                                                background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[50],
                                                p:2,
                                                borderRadius:4,
                                                display:"flex",
                                                gap:4,
                                                justifyContent:'space-between',
                                                "@media screen and (max-width: 1500px)" : {
                                                    flexDirection:'column',
                                                    gap:2,
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    flexDirection:'column',
                                                    "@media screen and (max-width: 1500px)" : {
                                                        flexDirection:'row',
                                                        justifyContent:"space-between"
                                                    }

                                                }}
                                            >
                                                <Text>{t("to_receive")}</Text>
                                                <Subheading bold>{(inboundLineToEdit.amounts.forecasted - inboundLineToEdit.amounts.received > 0 ? (inboundLineToEdit.amounts.forecasted - inboundLineToEdit.amounts.received) : 0)}</Subheading>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    gap:4,
                                                    "@media screen and (max-width: 1500px)" : {
                                                        flexDirection:'column',
                                                        gap:1,
                                                    }

                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display:"flex",
                                                        flexDirection:'column',
                                                        "@media screen and (max-width: 1500px)" : {
                                                            flexDirection:'row',
                                                            justifyContent:"space-between"
                                                        }

                                                    }}
                                                >
                                                    <Text>{t("forecasted")}</Text>
                                                    <Text bold>{inboundLineToEdit.amounts.forecasted}</Text>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display:"flex",
                                                        flexDirection:'column',
                                                        "@media screen and (max-width: 1500px)" : {
                                                            flexDirection:'row',
                                                            justifyContent:"space-between"
                                                        }

                                                    }}
                                                >
                                                    <Text>{t("received")}</Text>
                                                    <Box
                                                        sx={{
                                                            display:"flex",
                                                            color:colors.txt["primary"],
                                                            gap:1.5,
                                                        }}
                                                    >
                                                        <Text bold>{inboundLineToEdit.amounts.received}</Text>
                                                        {inboundLineToEdit?.amounts?.received > inboundLineToEdit?.amounts?.moved &&
                                                            <ButtonBase
                                                                onClick={() => updateAmountReceivedModal.setOpen(true)}
                                                                sx={{
                                                                    borderRadius:"50%",
                                                                }}
                                                            >
                                                                <EditOutlined fontSize="small"/>
                                                            </ButtonBase>
                                                        }
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display:"flex",
                                                        flexDirection:'column',
                                                        "@media screen and (max-width: 1500px)" : {
                                                            flexDirection:'row',
                                                            justifyContent:"space-between"
                                                        }

                                                    }}
                                                >
                                                    <Text>{t("moved")}</Text>
                                                    <Text bold>{inboundLineToEdit.amounts.moved}</Text>
                                                </Box>
                                            </Box>
                                        </Box>

                                    

                                        <Subheading
                                            sx={{
                                                mt:3,
                                            }}
                                        >{t("dimensions_and_weight")}</Subheading>
                                        <Box
                                            className={cx('', {
                                                'required-not-filled':  (props.dimensionsAndWeightRequired && (inboundLineToEdit.dimensionsAndWeight.length === '' || !(/^[1-9]\d*$/.test(inboundLineToEdit.dimensionsAndWeight.length))))
                                            })}
                                            sx={{
                                                background: colors.green[100],
                                                border: `1px solid ${colors.green[400]}`,
                                                display:"flex",
                                                mt:1,
                                                alignItems:'center',
                                                borderRadius:4,
                                                overflow:'hidden',
                                                px:0.5,
                                                "&.required-not-filled" : {
                                                    border: `1px solid ${colors.red[400]}`,
                                                    background: colors.red[100]
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    textAlign:"center"
                                                }}
                                            >

                                                <Text>{t("length")}</Text>
                                            </Box>
                                            <InputBase 
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                        setInBoundLineToEdit(inboundLineToEdit => {
                                                            return ({
                                                                ...inboundLineToEdit,
                                                                dimensionsAndWeight: {
                                                                    ...inboundLineToEdit.dimensionsAndWeight,
                                                                    length: !isNaN(parseInt(input)) ? parseInt(input) : "",
                                                                    hasBeenEditted: true,
                                                                }
                                                            })
                                                        })
                                                    }
                                                }}
                                                value={inboundLineToEdit.dimensionsAndWeight.length}
                                                sx={{
                                                    width:1,
                                                    height:32,
                                                    px:1.5,

                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:56,
                                                    textAlign:"center"
                                                }}
                                            >
                                                <Text>{t("mm")}</Text>
                                            </Box>
                                        </Box>
                                        
                                        <Box
                                            className={cx('', {
                                                'required-not-filled':  (props.dimensionsAndWeightRequired && (inboundLineToEdit.dimensionsAndWeight.width === '' || !(/^[1-9]\d*$/.test(inboundLineToEdit.dimensionsAndWeight.width)))) 
                                            })}
                                            sx={{
                                                // background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                                                background: colors.green[100],
                                                border: `1px solid ${colors.green[400]}`,
                                                display:"flex",
                                                mt:1,
                                                alignItems:'center',
                                                borderRadius:4,
                                                overflow:'hidden',
                                                px:0.5,
                                                "&.required-not-filled" : {
                                                    border: `1px solid ${colors.red[400]}`,
                                                    background: colors.red[100]
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    textAlign:"center"
                                                }}
                                            >

                                                <Text>{t("width")}</Text>
                                            </Box>
                                            <InputBase 
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                        setInBoundLineToEdit(inboundLineToEdit => ({
                                                            ...inboundLineToEdit,
                                                            dimensionsAndWeight: {
                                                                ...inboundLineToEdit.dimensionsAndWeight,
                                                                width: !isNaN(parseInt(input)) ? parseInt(input) : "",
                                                                hasBeenEditted: true,
                                                            }
                                                        }))
                                                    }
                                                }}
                                                value={inboundLineToEdit.dimensionsAndWeight.width}
                                                sx={{
                                                    width:1,
                                                    height:32,
                                                    px:1.5,

                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:56,
                                                    textAlign:"center"
                                                }}
                                            >
                                                <Text>{t("mm")}</Text>
                                            </Box>
                                        </Box>

                                        <Box
                                            className={cx('', {
                                                'required-not-filled':  (props.dimensionsAndWeightRequired && (inboundLineToEdit.dimensionsAndWeight.height === '' || !(/^[1-9]\d*$/.test(inboundLineToEdit.dimensionsAndWeight.height)))) 
                                            })}
                                            sx={{
                                                background: colors.green[100],
                                                border: `1px solid ${colors.green[400]}`,
                                                display:"flex",
                                                mt:1,
                                                alignItems:'center',
                                                borderRadius:4,
                                                overflow:'hidden',
                                                px:0.5,
                                                "&.required-not-filled" : {
                                                    border: `1px solid ${colors.red[400]}`,
                                                    background: colors.red[100]
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    textAlign:"center"
                                                }}
                                            >

                                                <Text>{t("height")}</Text>
                                            </Box>
                                            <InputBase 
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                        setInBoundLineToEdit(inboundLineToEdit => ({
                                                            ...inboundLineToEdit,
                                                            dimensionsAndWeight: {
                                                                ...inboundLineToEdit.dimensionsAndWeight,
                                                                height: !isNaN(parseInt(input)) ? parseInt(input) : "",
                                                                hasBeenEditted: true,
                                                            }
                                                        }))
                                                    }
                                                }}
                                                value={inboundLineToEdit.dimensionsAndWeight.height}
                                                sx={{
                                                    width:1,
                                                    height:32,
                                                    px:1.5,

                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:56,
                                                    textAlign:"center"
                                                }}
                                            >
                                                <Text>{t("mm")}</Text>
                                            </Box>
                                        </Box>

                                        <Box
                                            className={cx('', {
                                                'required-not-filled':  (props.dimensionsAndWeightRequired && (inboundLineToEdit.dimensionsAndWeight.weight === '' || !(/^[1-9]\d*$/.test(inboundLineToEdit.dimensionsAndWeight.weight)))) 
                                            })}
                                            sx={{
                                                background: colors.green[100],
                                                border: `1px solid ${colors.green[400]}`,
                                                display:"flex",
                                                mt:1,
                                                alignItems:'center',
                                                borderRadius:4,
                                                overflow:'hidden',
                                                px:0.5,
                                                "&.required-not-filled" : {
                                                    border: `1px solid ${colors.red[400]}`,
                                                    background: colors.red[100]
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    textAlign:"center"
                                                }}
                                            >

                                                <Text>{t("weight")}</Text>
                                            </Box>
                                            <InputBase 
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                        setInBoundLineToEdit(inboundLineToEdit => ({
                                                            ...inboundLineToEdit,
                                                            dimensionsAndWeight: {
                                                                ...inboundLineToEdit.dimensionsAndWeight,
                                                                weight: !isNaN(parseInt(input)) ? parseInt(input) : "",
                                                                hasBeenEditted: true,
                                                            }
                                                        }))
                                                    }
                                                }}
                                                value={inboundLineToEdit.dimensionsAndWeight.weight}
                                                sx={{
                                                    width:1,
                                                    height:32,
                                                    px:1.5,

                                                }}
                                            />
                                            <Box
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:56,
                                                    textAlign:"center"
                                                }}
                                            >
                                                <Text>{t("gram")}</Text>
                                            </Box>
                                        </Box>

                                        <ShDropdownQuery
                                            key={inboundLineToProcess.flags.carrierId}
                                            name="name"
                                            onChange={(selected,object) => {
                                                setInboundLineToProcess(prev => ({
                                                    ...prev,
                                                    flags: {
                                                        ...prev.flags,
                                                        carrierId: selected,
                                                    }
                                                }));
                                                setSelectedCarrier(object);
                                            }}
                                            searchOptions={{
                                                enabled: true,
                                                allowSelectionOnEnter:true,
                                                placeholder:t("search")
                                            }}
                                            displayName={"name"}
                                            valueKey={"id"}
                                            dataKey={null}
                                            shComponent={<CustomMyComponent/>}
                                            selected={inboundLineToProcess?.flags?.carrierId ?? -1}
                                            content={useGetCarriersSelectQuery}
                                            closeOnSelection
                                        >
                                            {({anchorEl,onClick}) => (
                                            <ButtonBase
                                                className={cx('', {
                                                    'required-not-filled': props.carrierRequired && (!inboundLineToProcess.flags.carrierId || inboundLineToProcess.flags.carrierId === -1)
                                                })}
                                                onClick={onClick}
                                                sx={{
                                                    mb:1.5,
                                                    mt:1.5,
                                                    width:1,
                                                    height:40,
                                                    borderRadius:5,
                                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                                    display:"flex",
                                                    alignItems:'center',
                                                    px:0.5,
                                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                                    border:`1px solid ${colors.grey[100]}`,
                                                    "&.required-not-filled" : {
                                                        background:colors.red[100],
                                                        border:`1px solid ${colors.red[400]}`,
                                                    }
                                                
                                                }}
                                            >

                                                    <Box
                                                        sx={{
                                                            height:32,
                                                            lineHeight:"32px",
                                                            background: theme.palette.mode === "dark" ? colors.grey[500] :  colors.grey[400],
                                                            borderRadius:4,
                                                            // border: `1px solid ${theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                                            width:80,
                                                            textAlign:"center",
                                                            fontSize:14,
                                                            fontWeight:"bold",
                                                            color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                        }}
                                                    >
                                                        {t("carrier")}

                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            flex:1,
                                                            ml:1.5,
                                                            mr:1.5,
                                                            minWidth:120,
                                                            textAlign:"left",
                                                        }}
                                                    >
                                                        <Text bold >
                                                            {selectedCarrier?.name ?? t("no_selection")}
                                                        </Text>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display:'flex',
                                                            gap:1.5,
                                                            alignItems:'center',
                                                        }}
                                                    >
                                                    
                                                        <Box

                                                            className={cx('', {
                                                                'required-not-filled': props.carrierRequired && (!inboundLineToProcess.flags.carrierId || inboundLineToProcess.flags.carrierId === -1)
                                                            })}
                                                            sx={{
                                                                height:32,
                                                                width:32,
                                                                borderRadius:4,
                                                                display:"flex",
                                                                alignItems:'center',
                                                                justifyContent:"center",
                                                                background: theme.palette.mode === "dark" ? colors.white[100] :  colors.grey[100],
                                                                border: `1px solid ${ theme.palette.mode === "dark" ? colors.white[400] :  colors.grey[400]}`,
                                                                color:  theme.palette.mode === "dark" ? colors.white[400] :  colors.grey[400],
                                                                "&.required-not-filled" : {
                                                                    background:colors.red[400],
                                                                    borderColor:colors.red[400],
                                                                    color:theme.palette.mode === 'dark' ? colors.txt["primaryDark"] : colors.txt['light'],
                                                                }
                                                            }}
                                                        >
                                                            <KeyboardArrowDownIcon/>

                                                        </Box>
                                                    </Box>

                                                </ButtonBase>
                                            )}
                                        </ShDropdownQuery>
                                        {/* Product field values */}
                                        {inboundLineToProcess?.flags?.productFields?.length > 0 && (
                                            <Box
                                                sx={{
                                                    mt:3,
                                                    mb:1.5,
                                                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                                    border:`1px solid ${colors.grey[100]}`,
                                                    borderRadius:4,
                                                    p:1.5,
                                                }}
                                            >
                                                <Subheading>{t("product_fields")}</Subheading>
                                                {inboundLineToProcess.flags.productFields.map((field) => {
                                                    const fieldValue = inboundLineToEdit.dimensionsAndWeight?.productFieldValues?.find(
                                                        pf => pf.productfieldId === field.id
                                                    );
                                                    const currentValue = fieldValue?.value ?? "";

                                                    if (field.valueType === "list") {
                                                        const listOptions = field.listValues?.map((item, index) => ({ id: index, name: item })) ?? [];
                                                        return (
                                                            <DropdownBaseV2
                                                                key={`pf-${field.id}`}
                                                                options={listOptions}
                                                                displayName="name"
                                                                closeOnSelection
                                                                selected={listOptions.findIndex(opt => opt.name === currentValue)}
                                                                onChange={(index) => {
                                                                    const selectedValue = listOptions[index]?.name ?? "";
                                                                    handleProductFieldValueChange(field.id, selectedValue);
                                                                }}
                                                            >
                                                                {({options, selected, onClick}) => (
                                                                    <ButtonBase
                                                                        onClick={onClick}
                                                                        sx={{
                                                                            mt:1,
                                                                            width:1,
                                                                            height:40,
                                                                            borderRadius:5,
                                                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                                                            display:"flex",
                                                                            alignItems:'center',
                                                                            px:0.5,
                                                                            boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                                                            border:`1px solid ${colors.grey[100]}`,
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                height:32,
                                                                                lineHeight:"32px",
                                                                                background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[400],
                                                                                borderRadius:4,
                                                                                minWidth:80,
                                                                                textAlign:"center",
                                                                                fontSize:14,
                                                                                fontWeight:"bold",
                                                                                color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                                                px:1,
                                                                            }}
                                                                        >
                                                                            {field.name}
                                                                        </Box>
                                                                        <Box
                                                                            sx={{
                                                                                flex:1,
                                                                                ml:1.5,
                                                                                mr:1.5,
                                                                                minWidth:120,
                                                                                textAlign:"left",
                                                                            }}
                                                                        >
                                                                            <Text bold>{currentValue || t("no_selection")}</Text>
                                                                        </Box>
                                                                        <Box
                                                                            sx={{
                                                                                height:32,
                                                                                width:32,
                                                                                borderRadius:4,
                                                                                display:"flex",
                                                                                alignItems:'center',
                                                                                justifyContent:"center",
                                                                                background: theme.palette.mode === "dark" ? colors.white[100] : colors.grey[100],
                                                                                border: `1px solid ${theme.palette.mode === "dark" ? colors.white[400] : colors.grey[400]}`,
                                                                                color: theme.palette.mode === "dark" ? colors.white[400] : colors.grey[400],
                                                                            }}
                                                                        >
                                                                            <KeyboardArrowDownIcon/>
                                                                        </Box>
                                                                    </ButtonBase>
                                                                )}
                                                            </DropdownBaseV2>
                                                        );
                                                    }

                                                    if (field.valueType === "text") {
                                                        return (
                                                            <Box
                                                                key={`pf-${field.id}`}
                                                                sx={{
                                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                                    display:"flex",
                                                                    mt:1,
                                                                    alignItems:'center',
                                                                    borderRadius:4,
                                                                    overflow:'hidden',
                                                                    px:0.5,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                                        height:24,
                                                                        borderRadius:3,
                                                                        textAlign:"center",
                                                                        px:1,
                                                                    }}
                                                                >
                                                                    <Text>{field.name}</Text>
                                                                </Box>
                                                                <InputBase
                                                                    value={currentValue}
                                                                    onChange={(e) => handleProductFieldValueChange(field.id, e.target.value)}
                                                                    sx={{
                                                                        width:1,
                                                                        height:32,
                                                                        px:1.5,
                                                                    }}
                                                                />
                                                            </Box>
                                                        );
                                                    }

                                                    if (field.valueType === "number") {
                                                        return (
                                                            <Box
                                                                key={`pf-${field.id}`}
                                                                sx={{
                                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                                    display:"flex",
                                                                    mt:1,
                                                                    alignItems:'center',
                                                                    borderRadius:4,
                                                                    overflow:'hidden',
                                                                    px:0.5,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                                        height:24,
                                                                        borderRadius:3,
                                                                        textAlign:"center",
                                                                        px:1,
                                                                    }}
                                                                >
                                                                    <Text>{field.name}</Text>
                                                                </Box>
                                                                <InputBase
                                                                    value={currentValue}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (input === '' || /^\d*$/.test(input)) {
                                                                            handleProductFieldValueChange(field.id, input === '' ? '' : parseInt(input));
                                                                        }
                                                                    }}
                                                                    sx={{
                                                                        width:1,
                                                                        height:32,
                                                                        px:1.5,
                                                                    }}
                                                                />
                                                            </Box>
                                                        );
                                                    }

                                                    if (field.valueType === "boolean") {
                                                        return (
                                                            <Box
                                                                key={`pf-${field.id}`}
                                                                sx={{
                                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                                    display:"flex",
                                                                    mt:1,
                                                                    alignItems:'center',
                                                                    borderRadius:4,
                                                                    height:32,
                                                                    px:0.5,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[0],
                                                                        height:24,
                                                                        borderRadius:3,
                                                                        textAlign:"center",
                                                                        px:1,
                                                                    }}
                                                                >
                                                                    <Text>{field.name}</Text>
                                                                </Box>
                                                                <ShSwitch
                                                                    checked={currentValue ?? false}
                                                                    onChange={(e) => handleProductFieldValueChange(field.id, e.target.checked)}
                                                                    sx={{
                                                                        marginLeft:"auto",
                                                                        marginRight:"-4px",
                                                                    }}
                                                                />
                                                            </Box>
                                                        );
                                                    }

                                                    return null;
                                                })}
                                            </Box>
                                        )}
                                        <Box sx={{display: "flex", flexDirection:"column",gap:1,}}>
                                            <ButtonBase 
                                                disabled={countInboundLoading || updateProductLoading}
                                                onClick={() => handleCount(false)}
                                                ref={buttonRef}
                                                className={cx('', {
                                                    'disabled': !isValidForProcessing,
                                                })}
                                                onMouseEnter={doHover}
                                                onMouseLeave={doUnhover}
                                                sx={{
                                                    mt:1.5,
                                                    width:1,
                                                    height:32,
                                                    px:2,
                                                    background:themeSettings(theme.palette.mode).palette.grey.main,
                                                    color: themeSettings(theme.palette.mode).palette.grey.contrastText,
                                                    borderRadius:4,
                                                    fontSize:14,
                                                    fontWeight:"bold",
                                                    "&.disabled" : {
                                                        opacity:0.55
                                                    }
                                                }}
                                            >
                                                {t("save")}
                                            </ButtonBase>
                                            <ButtonBase 
                                                disabled={countInboundLoading || updateProductLoading}
                                                onClick={() => handleCount(true)}   
                                                // onClick={handleCount}
                                                // ref={buttonRef}
                                                className={cx('', {
                                                    'disabled': !isValidForProcessingAndFinish,
                                                })}
                                                onMouseEnter={doHover}
                                                onMouseLeave={doUnhover}

                                                sx={{
                                                    mt:1.5,
                                                    width:1,
                                                    height:32,
                                                    px:2,
                                                    color:themeSettings(theme.palette.mode).palette.grey.main,
                                                    // background: themeSettings(theme.palette.mode).palette.grey.contrastText,
                                                    borderRadius:4,
                                                    fontSize:14,
                                                    fontWeight:"bold",
                                                    "&.disabled" : {
                                                        opacity:0.55
                                                    }
                                                }}
                                            >
                                                {t("save_and_finish")}
                                            </ButtonBase>
                                        </Box>
                                        <Popper
                                            open={isHovered && shouldBeShown}            
                                            anchorEl={anchorEl}   
                                            placement="bottom-start"  
                                            disableInteractive={true}  
                                        >
                                            <Box
                                                sx={{
                                                    mt:1.5,
                                                    background: "#fff",
                                                    padding: 2,
                                                    boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                                    borderRadius: 4,
                                                    zIndex: 9999, // Ensure it's above other elements
                                                    maxWidth:350,
                                                }}
                                            >
                                                <Subheading>{t("requirements_not_met")}</Subheading>
                                                {!checkAmountCounted() && 
                                                    <Box sx={{
                                                        mt:2,
                                                    }}>
                                                        <Text bold>{t("count")}</Text><br/>
                                                        <Text>{t("insufficient_amount_counted")}</Text>
                                                    </Box>
                                                }
                                                {(!inboundLineToProcess.flags.carrierId || inboundLineToProcess.flags.carrierId === -1) &&
                                                    <Box sx={{
                                                        mt:2,
                                                    }}>
                                                        <Text bold>{t("carrier_required")}</Text><br/>
                                                        <Text>{t("carrier_invalid")}</Text>
                                                    </Box>
                                                }
                                                {props.dimensionsAndWeightRequired && !isValidDimensionsAndWeight() && 
                                                    <Box sx={{
                                                        mt:2,
                                                    }}>
                                                        <Text bold>{t("dimensions_and_weight")}</Text><br/>
                                                        <Text>{t("dimensions_and_weight_invalid")}</Text>
                                                    </Box>
                                                }
                                                {checkLotAmount() && 
                                                    <Box sx={{
                                                        mt:2,
                                                    }}>
                                                        <Text bold>{t("lots")}</Text><br/>
                                                        <Text>{t("lot_insufficient_explanation")}</Text>
                                                    </Box>
                                                }
                                                {checkBatchAmount() && 
                                                    <Box sx={{
                                                        mt:2,
                                                    }}>
                                                        <Text bold>{t("batches")}</Text><br/>
                                                        <Text>{t("batches_insufficient_explanation")}</Text>
                                                    </Box>
                                                }
                                                {checkRepackAmount() && 
                                                    <Box sx={{
                                                        mt:2,
                                                    }}>
                                                        <Text bold>{t("repackingorders")}</Text><br/>
                                                        <Text>{t("repacking_insufficient_explanation")}</Text>
                                                    </Box>
                                                } 
                                                {checkSerialNumberAmount() && (
                                                    <Box sx={{ mt: 2 }}>
                                                        <Text bold>{t("serial_numbers")}</Text>
                                                        <br />
                                                        <Text>{t("serial_numbers_insufficient")}</Text>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Popper>

                                    </Box>
                                : 
                                    <Box
                                        sx={{
                                            flex:1,
                                            background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                            borderRadius:4,
                                            p:3,
                                            textAlign:"center",
                                            display:"flex",
                                            flexDirection:"column",
                                            gap:2,
                                            alignItems:"center",
                                            py:6,

                                        }}
                                    >
                                        <Subheading>{t("already_counted")}</Subheading>
                                        <Text>{t("do_a_second_count")}</Text>
                                        <Shbutton
                                            onClick={() => setWasCounted(false)}
                                            size={"32"}
                                            variant="contained"
                                        >
                                            {t("count_again")}
                                        </Shbutton>
                                    </Box>
                                }
                                {(inboundLineToProcess.flags.serialNumberRequired || inboundLineToProcess?.serialnumbers.length > 0) &&
                                    <Box
                                        sx={{
                                            pt:3,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display:'flex',
                                                justifyContent:"space-between",
                                                alignItems:"flex-end",
                                            }}
                                        >
                                            <Subheading>{t("serial_numbers")}</Subheading>
                                            {/* {inboundLineToProcess?.serialnumbers?.length < inboundLineToEdit?.amounts.received &&
                                                <Shbutton
                                                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                                                    variant="contained"
                                                    size={"32"}
                                                    onClick={() => {
                                                        createSerialNumberModal.setOpen(true);
                                                    }}
                                                >
                                                    {t("create_serial_number")}
                                                </Shbutton>
                                            } */}
                                        </Box>
                                        <Box
                                            sx={{
                                                mt:2,
                                                flex:1,
                                                background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                                borderRadius:4,
                                                p:3,
                                                display:"flex",
                                                flexDirection:"column",
                                                gap:1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    p:2,
                                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200],
                                                    mb:2,
                                                    borderRadius:10,
                                                }}
                                            >
                                                <Box 
                                                    sx={{
                                                        display:'flex',
                                                        height:32,
                                                        background:theme.palette.mode === "dark" ? colors.grey[800] : colors.txt["white"],
                                                        justifyContent:"space-between",
                                                        borderRadius:5,
                                                        "@media screen and (max-width: 47.9375em)" : {
                                                            flexDirection:"column"
                                                        }
                                                    }}
                                                >
                                                    <img 
                                                        src="/img/barcode.svg" 
                                                        alt="Barcode" 
                                                        style={{
                                                            width: '24px', 
                                                            marginLeft:"16px",
                                                        }} 
                                                    />
            
                                                    <InputBase 
                                                        inputRef={serialNumberRef}
                                                        sx={{
                                                            ml: 2, 
                                                            flex:1, 
                                                            width: 248, 
                                                            textAlign: 'center', 
                                                            justifyContent: 'center'
                                                        }} 
                                                        placeholder={t("scan_type_barcode")}
                                                        onKeyDown={handleSerialnumber}
                                                        // autoFocus={true}
                                                    />
                                                </Box>
                                            </Box>
                                            {inboundLineToProcess?.serialnumbers.map((serialNumber, idex) => {
                                                const {labelcolor, labeltext} = getSerialNumberStateLabeldata(serialNumber.state, theme);
                                                return (
                                                    <Box
                                                        sx={{
                                                            height:32,
                                                            background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                            borderRadius:5,
                                                            pl:2,
                                                            pr:0.5,
                                                            lineHeight:"32px",
                                                            display:'flex',
                                                                alignItems:'center'
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                width:1,
                                                                display:'flex',
                                                                justifyContent:"space-between",
                                                                alignItems:'center'

                                                            }}
                                                        >
                                                            <Text>{serialNumber.barcode}</Text>

                                                            <ShLabel
                                                                size={24}
                                                                fitted
                                                                palette="normal"
                                                                variant={labelcolor}
                                                            >
                                                                {t(labeltext)}
                                                            </ShLabel>
                                                        </Box>
                                                        {serialNumber.state != general_states.ACTIVE ?
                                                            <ButtonBase
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    setItem(serialNumber);
                                                                    handleAmStreamInProgressPopoverClick(event);
                                                                }}
                                                                sx={{
                                                                    height:32,
                                                                    width:32,
                                                                    flexShrink:0,
                                                                    display:'flex',
                                                                    alignItems:'center',
                                                                    justifyContent:"center",
                                                                    borderRadius:4,
                                                                    ml:1,
                                                                }}
                                                            >
                                                                <MoreVertIcon/>
                                                            </ButtonBase>
                                                        :
                                                            <ButtonBase
                                                                onClick={() => {
                                                                    setPrintSnBarcode(serialNumber.barcode);
                                                                    printSnBarcodeModal.setOpen(true);
                                                                }}
                                                                sx={{
                                                                    mr:0.5,
                                                                    ml:1,
                                                                    height:24,
                                                                    width:24,
                                                                    borderRadius:4,
                                                                }}
                                                            >
                                                                <LocalPrintshopOutlined fontSize="small"/>
                                                            </ButtonBase>
                                                        }
                                                    </Box>
                                                );
                                            
                                            })}
                                            {showAddButton &&
                                                <ButtonBase
                                                    onClick={() => {
                                                        addSnModal.setOpen(true);
                                                    }}
                                                    sx={{
                                                        background:theme.palette.mode === "dark" ? colors.txt['secondary'] : colors.grey[400],
                                                        color: theme.palette.mode === "dark" ? colors.txt['primary'] : colors.txt['light'],
                                                        height:32,
                                                        borderRadius:4,
                                                        lineHeight:"32px",
                                                        width:1,
                                                        textAlign:'center',
                                                    }}
                                                >
                                                    {t("create_serial_number")}
                                                </ButtonBase>
                                            }

                                        </Box>
                                    </Box>
                                }
                                {hasInboundProcessPcPermission && (wasCounted || defaultLocationAmount > 0) &&
                                    <PlacePanel
                                        locations={locations}
                                        showWarehouseSelector={showWarehouseSelector}
                                        selectedLocationWarehouseId={selectedLocationWarehouseId}
                                        setSelectedLocationWarehouseId={setSelectedLocationWarehouseId}
                                        warehouses={warehouses}
                                        locationWarehouseSelected={locationWarehouseSelected}
                                        locationFilters={locationFilters}
                                        setLocationFilters={setLocationFilters}
                                        lots={inboundLineToEdit?.lots}
                                        batches={inboundLineToEdit?.batches}
                                        flags={inboundLineToProcess?.flags}
                                        inboundLineToEdit={inboundLineToEdit}
                                        serialnumbers={inboundLineToProcess?.serialnumbers}
                                        inboundLineId={inboundLineToEdit?.inboundLine?.id}
                                        maxAmount={defaultLocationAmount}
                                        setHighlightColor={props.setHighlightColor}
                                        onPlaceSuccess={() => {
                                            props.getInbound(props.incData.id);
                                            refetchJobAndLoad();
                                        }}
                                    />
                                }

                                {/* Scanner capture needs the inbound barcode support that ships with the next app release. */}
                                <LinePhotos
                                    photos={photosData || []}
                                    onAddFromPC={() => handleOpenPhotoModal('pc')}
                                    onAddFromScanner={() => handleOpenPhotoModal('scanner')}
                                    onDelete={handleDeletePhoto}
                                    onPhotoClick={handlePhotoClick}
                                    isLoading={photosLoading || isDeletingPhoto}
                                    showScanner={false}
                                />
                            </Box>

                            <Box
                                sx={{
                                    flex:1,
                                    "@media screen and (max-width: 1500px)" : {
                                        flex:2,
                                        flexShrink:0,
                                    }

                                }}
                            >
                                <Box
                                    sx={{

                                        display:"flex",
                                        gap:2,
                                    }}
                                >
                                    {/* Repack assignment */}
                                    {(inboundLineToProcess.flags.canDoRepacking || inboundLineToProcess.flags.repackingRequired)  &&
                                        <Box
                                            className={cx('',{
                                                "opacify": (!inboundLineToProcess.flags.repackingRequired && !wasCounted && inboundLineToProcess.flags.canDoRepacking && (inboundLineToEdit.amounts?.counted.length === 0 || isNaN(inboundLineToEdit.amounts?.counted)))
                                            })}
                                            sx={{
                                                flex:1,
                                                background:theme.palette.mode === "dark" ? colors.pink[100] : colors.pink[100],
                                                border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                                boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                                p:3,
                                                borderRadius:4,
                                                display:"flex",
                                                flexDirection:'column',
                                                "&.opacify": {
                                                    userSelect:"none",
                                                    pointerEvents:"none",
                                                    opacity:0.35
                                                }
                                            }}
                                        >
                                            <Subheading>{t("repackingorders")}</Subheading>
                                            {inboundLineToProcess?.flags.repackingRequired &&
                                                <Box
                                                    sx={{
                                                        mt:1,
                                                        mb:2,
                                                    }}
                                                >
                                                    <Text>{t("to_process")}</Text> <Text bold>{repackLeftToDo()}</Text>
                                                </Box>
                                            }

                                            {/* <Box
                                                className={cx('', {
                                                    'required-not-filled': checkRepackAmount()
                                                })}
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.pink[200] : colors.pink[100],
                                                    display:"flex",
                                                    mt:1,
                                                    alignItems:'center',
                                                    borderRadius:4,
                                                    overflow:'hidden',
                                                    px:0.5,
                                                    "&.required-not-filled" : {
                                                        border: `1px solid ${colors.red[400]}`,
                                                        background: colors.red[100]
                                                    }
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                        height:24,
                                                        borderRadius:3,
                                                        minWidth:80,
                                                        textAlign:"center"
                                                    }}
                                                >

                                                    <Text color={theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"]} >{t("amount")}</Text>
                                                </Box>
                                                <InputBase 
                                                    onChange={(e) => {
                                                        const input = e.target.value;
                                                        if (/^\d*$/.test(input)) {
                                                            if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                                setRepackOrderData(repackOrderData => ({
                                                                    ...repackOrderData,
                                                                    amount: input,
                                                                }))
                                                            }
                                                        }
                                                    }}
                                                    value={repackOrderData.amount}
                                                    sx={{
                                                        width:1,
                                                        height:32,
                                                        px:1.5,

                                                    }}
                                                />
                                            </Box>

                                            <Box
                                                className={cx('', {
                                                    'required-not-filled': checkRepackAmount()
                                                })}
                                                sx={{
                                                    background: theme.palette.mode === "dark" ? colors.pink[200] : colors.pink[100],
                                                    display:"flex",
                                                    mt:1,
                                                    alignItems:'center',
                                                    borderRadius:4,
                                                    overflow:'hidden',
                                                    px:0.5,
                                                    
                                                    "&.required-not-filled" : {
                                                        border: `1px solid ${colors.red[400]}`,
                                                        background: colors.red[100]
                                                    }
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                        height:24,
                                                        borderRadius:3,
                                                        minWidth:80,
                                                        textAlign:"center"
                                                    }}
                                                >

                                                    <Text color={theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"]} >{t("colli")}</Text>
                                                </Box>
                                                <InputBase 
                                                    onChange={(e) => {
                                                        const input = e.target.value;
                                                        if (/^\d*$/.test(input)) {
                                                            if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                                setRepackOrderData(repackOrderData => ({
                                                                    ...repackOrderData,
                                                                    colli: input,
                                                                }))
                                                            }
                                                        }
                                                    }}
                                                    value={repackOrderData.colli}
                                                    sx={{
                                                        width:1,
                                                        height:32,
                                                        px:1.5,

                                                    }}
                                                />
                                            </Box> */}
                                            <Box
                                                sx={{
                                                    mt:"auto"
                                                }}
                                            >
                                                {!createRepackOrder &&
                                                    <ButtonBase
                                                        disabled={createRepackingOrderLoading}
                                                        // onClick={handleAddRepackOrder}
                                                        onClick={() => {
                                                            createRepackOrderModal.setOpen(true);
                                                        }}
                                                        sx={{
                                                            mt:1,
                                                            borderRadius:4,
                                                            width:1,
                                                            height:32,
                                                            lineHeight:"32px",
                                                            background: theme.palette.mode === "dark" ? colors.pink[400] : colors.pink[400],
                                                            fontSize:14,
                                                            fontWeight:"bold",
                                                            fontFamily:"Roboto, sans-serif",
                                                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]
                                                        }}
                                                    >
                                                        {t("create_repackingorder")}
                                                    </ButtonBase>
                                                }
                                                <ButtonBase
                                                    className={cx(undefined, {
                                                        'create-later-true':createRepackOrder,
                                                    })}
                                                    onClick={() => {
                                                        setCreateRepackOrder(prev => prev = !prev);
                                                    }}
                                                    sx={{
                                                        mt:1,
                                                        borderRadius:4,
                                                        width:1,
                                                        height:32,
                                                        lineHeight:"32px",
                                                        display:'flex',
                                                        alignItems:'center',
                                                        justifyContent:'space-between',
                                                        px:"3px",
                                                        // background: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                                                        border: `1px solid ${theme.palette.mode === "dark" ? colors.txt['primary'] : colors.grey[400]}`,
                                                        fontSize:14,
                                                        fontWeight:"bold",
                                                        fontFamily:"Roboto, sans-serif",
                                                        color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                        "&.create-later-true" : {
                                                            background: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.grey[400],
                                                            color: theme.palette.mode === "dark" ? colors.txt['primaryDark'] : colors.txt["light"],
                                                        }
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width:24,
                                                            height:24,
                                                        }}
                                                    />
                                                    {t("create_later")}

                                                    {createRepackOrder ?
                                                        <Box
                                                            sx={{
                                                                height:24,
                                                                width:24,
                                                                background: theme.palette.mode === "dark" ? colors.grey[200] : colors.txt["light"],
                                                                borderRadius:4,
                                                                color: theme.palette.mode === "dark" ? colors.txt['primary'] : colors.txt["primary"],
                                                            }}
                                                        >
                                                            <CheckOutlinedIcon fontSize="small"/>
                                                        </Box>
                                                    :
                                                        <Box
                                                            sx={{
                                                                height:24,
                                                                width:24,
                                                            }}
                                                        >

                                                        </Box>
                                                    }
                                                </ButtonBase>
                                            </Box>
                                        </Box>
                                    }

                                    {hasPrintBarcodePermission &&
                                    <Box
                                        sx={{
                                            flex:1,
                                            background:theme.palette.mode === "dark" ? colors.green[100] : colors.green[100],
                                            border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                            boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                            p:3,
                                            borderRadius:4,
                                            display:"flex",
                                            flexDirection:'column',
                                        }}
                                    >
                                        {props.selectedWorkSpace.id !== -1 ?
                                            <>
                                                <Subheading>{t("print_barcode")}</Subheading>

                                                {/* Barcode Selection */}
                                                <Box
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.green[100] : colors.green[100],
                                                        display:"flex",
                                                        mt:1,
                                                        alignItems:'center',
                                                        borderRadius:6,
                                                        overflow:'hidden',
                                                        px:0.5,
                                                        py:0.5,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                            height:40,
                                                            borderRadius:5,
                                                            minWidth:80,
                                                            textAlign:"center",
                                                            lineHeight:"40px"
                                                        }}
                                                    >
                                                        <Text color={theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"]} >{t("barcode")}</Text>
                                                    </Box>
                                                    <Box sx={{ flex: 1, pl: 1.5 }}>
                                                        <ShValidatedInputDropdown
                                                            height={40}
                                                            name="barcode"
                                                            displayName="label"
                                                            changeField="value"
                                                            variant={"green"}
                                                            selected={getBarcodeOptions().findIndex(option => option.value === printBarcodeData.barcode)}
                                                            options={getBarcodeOptions()}
                                                            noSelection={t("choose_barcode")}
                                                            onChange={(field, value) => {
                                                                setPrintBarcodeData(prev => ({
                                                                    ...prev,
                                                                    barcode: value
                                                                }));
                                                            }}
                                                            sx={{
                                                                '& .MuiInputBase-root': {
                                                                    height: 24,
                                                                    fontSize: 12,
                                                                    backgroundColor: 'transparent !important',
                                                                    border: 'none',
                                                                    boxShadow: 'none',
                                                                    '& fieldset': {
                                                                        border: 'none'
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        border: 'none'
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        border: 'none'
                                                                    }
                                                                },
                                                                '& .MuiSelect-select': {
                                                                    padding: '0 8px',
                                                                    backgroundColor: 'transparent !important'
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    backgroundColor: 'transparent !important'
                                                                }
                                                            }}
                                                        />
                                                    </Box>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.green[100] : colors.green[100],
                                                        display:"flex",
                                                        mt:1,
                                                        alignItems:'center',
                                                        borderRadius:4,
                                                        overflow:'hidden',
                                                        px:0.5,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                            height:24,
                                                            borderRadius:3,
                                                            minWidth:80,
                                                            textAlign:"center"
                                                        }}
                                                    >

                                                        <Text color={theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"]} >{t("amount")}</Text>
                                                    </Box>
                                                    <InputBase 
                                                        onChange={(e) => {
                                                            const input = e.target.value;
                                                            if (/^\d*$/.test(input)) {
                                                                if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                                    setPrintBarcodeData(printBarcodeData => ({
                                                                        ...printBarcodeData,
                                                                        amount: input,
                                                                    }))
                                                                }
                                                            }
                                                        }}
                                                        value={printBarcodeData.amount}
                                                        sx={{
                                                            width:1,
                                                            height:32,
                                                            px:1.5,

                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.green[100] : colors.green[100],
                                                        display:"flex",
                                                        mt:1,
                                                        alignItems:'center',
                                                        borderRadius:4,
                                                        overflow:'hidden',
                                                        px:0.5,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                            height:24,
                                                            borderRadius:3,
                                                            minWidth:80,
                                                            textAlign:"center"
                                                        }}
                                                    >

                                                        <Text color={theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"]} >{t("name")}</Text>
                                                    </Box>
                                                    <InputBase 
                                                        onChange={(e) => {
                                                            const input = e.target.value;
                                                            // Limit to 23 characters for barcode printing
                                                            if (input.length <= 23) {
                                                                setPrintBarcodeData(printBarcodeData => ({
                                                                    ...printBarcodeData,
                                                                    name: input,
                                                                }))
                                                            } else {
                                                                // Flash red when limit is hit
                                                                setNameFieldFlash(true);
                                                                setTimeout(() => setNameFieldFlash(false), 300);
                                                            }
                                                        }}
                                                        value={printBarcodeData.name}
                                                        sx={{
                                                            width:1,
                                                            height:32,
                                                            px:1.5,
                                                            backgroundColor: nameFieldFlash ? colors.red[200] : 'transparent',
                                                            transition: 'background-color 0.1s ease'
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    sx={{
                                                        height:32,
                                                        mt:1,
                                                        background: theme.palette.mode === "dark" ? colors.green[100] : colors.green[100],
                                                        borderRadius:4,
                                                        textAlign:"center",
                                                        display:"flex",
                                                        alignItems:"center",
                                                        px:0.5,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                                            height:24,
                                                            borderRadius:3,
                                                            minWidth:80,
                                                            textAlign:"center",
                                                            mr:1.5,
                                                        }}
                                                    >

                                                        <Text color={theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"]} >{t("workspace")}</Text>
                                                    </Box>
                                                    {props.selectedWorkSpace.name}
                                                </Box>



                                                <ButtonBase
                                                    disabled={printBarcodeLoading}
                                                    onClick={handlePrintBarcode}
                                                    sx={{
                                                        mt:1,
                                                        borderRadius:4,
                                                        width:1,
                                                        height:32,
                                                        lineHeight:"32px",
                                                        background: theme.palette.mode === "dark" ? colors.green[400] : colors.green[400],
                                                        fontSize:14,
                                                        fontWeight:"bold",
                                                        fontFamily:"Roboto, sans-serif",
                                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]
                                                    }}
                                                >
                                                    {t("print")}
                                                </ButtonBase>
                                            </>
                                        : 
                                            <SelectWorkSpace/> 
                                        }
                                    </Box>
                                    }
                                </Box>

                                {(inboundLineToProcess.flags.canCreateBatch || inboundLineToProcess.flags.batchRequired)  &&
                                    <Box
                                        className={cx('',{
                                            "opacify": (!inboundLineToProcess.flags.batchRequired && !wasCounted && inboundLineToProcess.flags.canCreateBatch && (inboundLineToEdit.amounts?.counted.length === 0 || isNaN(inboundLineToEdit.amounts?.counted)))
                                        })}
                                        sx={{
                                            mt:2,
                                            flex:1,
                                            background:theme.palette.mode === "dark" ? colors.orange[100] : colors.orange[100],
                                            border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                            boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                            p:3,
                                            borderRadius:4,
                                            "&.opacify": {
                                                userSelect:"none",
                                                pointerEvents:"none",
                                                opacity:0.35
                                            }
                                        }}
                                    >
                                        <Subheading>{t("batches")}</Subheading>

                                        <Box
                                            sx={{
                                                display:"flex",
                                                gap:2,
                                                mt:1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    flex:1,
                                                }}
                                            >

                                                <Text light bold>{t("barcode")}</Text>
                                            </Box>
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    width:80,
                                                    // flex:1,
                                                }}
                                            >

                                                <Text light bold>{t("amount")}</Text>
                                            </Box>
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    flex:1,
                                                }}
                                            >

                                                <Text light bold>{t("tht")}</Text>
                                            </Box>
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    flex:1.5,
                                                }}
                                            >

                                                <Text light bold>{t("batchnumber")}</Text>
                                            </Box>

                                        </Box>

                                        {inboundLineToEdit.batches.map((batch,index) => (

                                            <Box
                                                key={"batchindex"+index}
                                                sx={{
                                                    display:"flex",
                                                    gap:2,
                                                    height:32,
                                                    lineHeight:"32px"
                                                }}
                                            >
                                                <Text sx={{flex:1}}>{batch.barcode}</Text>
                                                <Text sx={{width:80}}>{batch.amount}</Text>
                                                <Text sx={{flex:1}} noBreak>
                                                    {batch.bbDate && new Date(batch.bbDate).toLocaleDateString(i18n.language)}
                                                </Text>
                                                <Box
                                                    sx={{
                                                        flex:1.5,
                                                        display:'flex',
                                                        alignItems:'center',
                                                        justifyContent:'space-between'
                                                    }}
                                                >
                                                    <Text>{batch.number}</Text>

                                                    <Box>
                                                        <ButtonBase
                                                            onClick={() => {
                                                                handlePrintGenericBarcode(
                                                                    batch.barcode ?? batch.number,
                                                                    parseInt(1),
                                                                    batch.brcode ?? batch.number,
                                                                );
                                                            }}
                                                        >
                                                            <PrintOutlined fontSize="small"/>
                                                        </ButtonBase>
                                                        <ButtonBase
                                                            onClick={() => {
                                                                setBatchToUpdate({...batch, inboundLineId: inboundLineToEdit?.inboundLine?.id});
                                                                updateBatchModal.setOpen(true)
                                                            }}

                                                            sx={{
                                                                ml:1,
                                                                borderRadius:4,
                                                            }}
                                                        >
                                                            <EditIcon fontSize="small"/>
                                                        </ButtonBase>

                                                        <ButtonBase
                                                            onClick={() => {
                                                                
                                                                setBatchToDelete(batch);
                                                                confirmDeleteBatchModal.setOpen(true);
                                                                // updateStockModal.setOpen(true)
                                                            }}

                                                            sx={{
                                                                ml:1,
                                                                borderRadius:4,
                                                                color:colors.red[400]
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small"/>
                                                        </ButtonBase>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}

                                        <Box
                                            sx={{
                                                display:"flex",
                                                gap:2,
                                            }}
                                        >
                                            <Box sx={{flex:1}}></Box>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    overflow:'hidden',
                                                    // flexDirection:'column',
                                                    width:80,
                                                }}
                                            >
                                                <InputBase 
                                                    className={cx('', {
                                                        'required-not-filled': checkBatchAmount(),
                                                        'required-filled': inboundLineToProcess.flags.batchRequired && !checkBatchAmount()
                                                    })}
                                                    onChange={(e) => {
                                                        const input = e.target.value;
                                                        if (/^\d*$/.test(input)) {
                                                            if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                                setBatchData(batchData => ({
                                                                    ...batchData,
                                                                    amount: input,
                                                                }))
                                                            }
                                                        }
                                                    }}
                                                    value={batchData.amount}
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.orange[200] : colors.orange[100],
                                                        width:1,
                                                        height:32,
                                                        px:1.5,
                                                        borderRadius:4,

                                                        "&.required-not-filled" : {
                                                            border: `1px solid ${colors.red[400]}`,
                                                            background: colors.red[100]
                                                        },
                                                        "&.required-filled" : {
                                                            border: `1px solid ${colors.green[400]}`,
                                                            background: colors.green[100]
                                                        }
                                                    }}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    overflow:'hidden',
                                                    // flexDirection:'column',
                                                    flex:1,
                                                }}
                                            >
                                                <ShDateRangePicker
                                                    explicit
                                                    singleSelect={true} 
                                                    startDate={batchData.bbDate}
                                                    shouldHide={batchData.bbDateWasNotChanged}
                                                    select={(data) => {
                                                        setBatchData(batchData => ({
                                                            ...batchData,
                                                            bbDate: data[0].formattedStartDate,
                                                            bbDateWasNotChanged: false,
                                                        }))
                                                    }} 
                                                    size={32}
                                                    sx={{
                                                        border: checkBatchAmount() ? `1px solid ${colors.red[400]}` : 
                                                                inboundLineToProcess.flags.batchRequired ? `1px solid ${colors.green[400]}` : null,
                                                      
                                                        background: checkBatchAmount() ? colors.red[100] : 
                                                                    inboundLineToProcess.flags.batchRequired ? colors.green[100] : 
                                                                    theme.palette.mode === "dark" ? colors.orange[200] : colors.orange[100],
                                                      
                                                        "&:hover": {
                                                          background: checkBatchAmount() ? colors.red[300] : 
                                                                      inboundLineToProcess.flags.batchRequired ? colors.green[300] : 
                                                                      theme.palette.mode === "dark" ? colors.orange[300] : colors.orange[200],
                                                        }
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    overflow:'hidden',
                                                    // flexDirection:'column',
                                                    flex:1.5,
                                                }}
                                            >
                                                <InputBase 
                                                    className={cx('', {
                                                        'required-not-filled': checkBatchAmount(),
                                                        'required-filled': inboundLineToProcess.flags.batchRequired && !checkBatchAmount()
                                                    })}
                                                    onChange={(e) => {
                                                        setBatchData(batchData => ({
                                                            ...batchData,
                                                            number: e.target.value,
                                                        }))
                                                    }}
                                                    value={batchData.number}
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.orange[200] : colors.orange[100],
                                                        width:1,
                                                        height:32,
                                                        px:1.5,
                                                        borderRadius:4,

                                                        "&.required-not-filled" : {
                                                            border: `1px solid ${colors.red[400]}`,
                                                            background: colors.red[100]
                                                        },
                                                        "&.required-filled" : {
                                                            border: `1px solid ${colors.green[400]}`,
                                                            background: colors.green[100]
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </Box>


                                        <ButtonBase
                                            disabled={createBatchLoading}
                                            onClick={handleAddBatch}
                                            sx={{
                                                mt:2,
                                                borderRadius:4,
                                                width:1,
                                                height:32,
                                                lineHeight:"32px",
                                                background: theme.palette.mode === "dark" ? colors.orange[400] : colors.orange[400],
                                                fontSize:14,
                                                fontWeight:"bold",
                                                fontFamily:"Roboto, sans-serif",
                                                color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]
                                            }}
                                        >
                                            {t("create_batch")}
                                        </ButtonBase>

                                    </Box>
                                }

                                {(inboundLineToProcess.flags.canCreateLot || inboundLineToProcess.flags.lotRequired)  &&
                                    <Box
                                        className={cx('',{
                                            "opacify": (!inboundLineToProcess.flags.lotRequired && !wasCounted && inboundLineToProcess.flags.canCreateLot && (inboundLineToEdit.amounts?.counted.length === 0 || isNaN(inboundLineToEdit.amounts?.counted)))
                                        })}
                                        sx={{
                                            mt:2,
                                            flex:1,
                                            background:theme.palette.mode === "dark" ? colors.blue[100] : colors.blue[100],
                                            border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                            boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                            p:3,
                                            borderRadius:4,
                                            "&.opacify": {
                                                userSelect:"none",
                                                pointerEvents:"none",
                                                opacity:0.35
                                            }
                                        }}
                                    >
                                        <Subheading>{t("lots")}</Subheading>

                                        <Box
                                            sx={{
                                                display:"flex",
                                                gap:2,
                                                mt:1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    flex:1,
                                                }}
                                            >

                                                <Text light bold>{t("amount")}</Text>
                                            </Box>
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    flex:1,
                                                }}
                                            >

                                                <Text light bold>{t("tht")}</Text>
                                            </Box>
                                            <Box
                                                sx={{
                                                    height:24,
                                                    borderRadius:3,
                                                    minWidth:80,
                                                    flex:1,
                                                }}
                                            >

                                                <Text light bold>{t("number")}</Text>
                                            </Box>

                                        </Box>

                                        {inboundLineToEdit.lots.map((lot,index) => (

                                            <Box
                                                key={"batchindex"+index}
                                                sx={{
                                                    display:"flex",
                                                    gap:2,
                                                    height:32,
                                                    lineHeight:"32px"
                                                }}
                                            >
                                                <Text sx={{flex:1}}>{lot.amountReceived}</Text>

                                                <Text sx={{flex:1}} noBreak>
                                                    {lot.bbDate && new Date(lot.bbDate).toLocaleDateString(i18n.language)}
                                                </Text>
                                                <Box
                                                    sx={{
                                                        flex:1,
                                                        display:'flex',
                                                        justifyContent:'space-between',
                                                        alignItems:"center"
                                                    }}
                                                >
                                                    <Text>{lot.number}</Text>
                                                    <Box>
                                                        <ButtonBase
                                                            onClick={() => {
                                                                setLotToUpdate(lot);
                                                                updateStockModal.setOpen(true)
                                                            }}

                                                            sx={{
                                                                borderRadius:4,
                                                            }}
                                                        >
                                                            <EditIcon fontSize="small"/>
                                                        </ButtonBase>

                                                        <ButtonBase
                                                            onClick={() => {
                                                                setLotToDelete(lot);
                                                                confirmDeleteLotLotModal.setOpen(true);
                                                                // updateStockModal.setOpen(true)
                                                            }}

                                                            sx={{
                                                                ml:1,
                                                                borderRadius:4,
                                                                color:colors.red[400]
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small"/>
                                                        </ButtonBase>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}

                                        <Box
                                            sx={{
                                                display:"flex",
                                                gap:2,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    overflow:'hidden',
                                                    flex:1,
                                                }}
                                            >
                                                <InputBase 
                                                    className={cx('', {
                                                        'required-not-filled': checkLotAmount(),
                                                        'required-filled': inboundLineToProcess.flags.lotRequired && !checkLotAmount()
                                                    })}
                                                    onChange={(e) => {

                                                        const input = e.target.value;
                                                        if (/^\d*$/.test(input)) {
                                                            if (input === '' || /^[1-9]\d*$/.test(input)) {
                                                                setLotData(batchData => ({
                                                                    ...batchData,
                                                                    amountReceived: input,
                                                                }))
                                                            }
                                                        }
                                                    }}
                                                    value={lotData.amountReceived}
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.blue[200] : colors.blue[200],
                                                        width:1,
                                                        height:32,
                                                        px:1.5,
                                                        borderRadius:4,

                                                        "&.required-not-filled" : {
                                                            border: `1px solid ${colors.red[400]}`,
                                                            background: colors.red[100]
                                                        },
                                                        "&.required-filled" : {
                                                            border: `1px solid ${colors.green[400]}`,
                                                            background: colors.green[100]
                                                        }
                                                    }}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    overflow:'hidden',
                                                    flex:1,
                                                }}
                                            >
                                                
                                                <ShDateRangePicker
                                                    explicit
                                                    singleSelect={true} 
                                                    shouldHide={lotData.bbDateWasNotChanged}
                                                    startDate={lotData.bbDate}
                                                    select={(data) => {
                                                        setLotData(lotData => ({
                                                            ...lotData,
                                                            bbDate: data[0].formattedStartDate,
                                                            bbDateWasNotChanged: false,
                                                        }))
                                                    }} 
                                                    size={32}
                                                    sx={{
                                                        border: checkLotAmount() ? `1px solid ${colors.red[400]}` : 
                                                                inboundLineToProcess.flags.lotRequired ? `1px solid ${colors.green[400]}` : null,
                                                      
                                                        background: checkLotAmount() ? colors.red[100] : 
                                                                    inboundLineToProcess.flags.lotRequired ? colors.green[100] : 
                                                                    theme.palette.mode === "dark" ? colors.blue[100] : colors.blue[200],
                                                      
                                                        "&:hover": {
                                                          background: checkLotAmount() ? colors.red[300] : 
                                                                      inboundLineToProcess.flags.lotRequired ? colors.green[300] : 
                                                                      theme.palette.mode === "dark" ? colors.blue[200] : colors.blue[200],
                                                        }
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    overflow:'hidden',
                                                    flex:1,
                                                }}
                                            >
                                                <InputBase 
                                                    className={cx('', {
                                                        'required-not-filled': checkLotAmount(),
                                                        'required-filled': inboundLineToProcess.flags.lotRequired && !checkLotAmount()
                                                    })}
                                                    onChange={(e) => {
                                                        setLotData(lotData => ({
                                                            ...lotData,
                                                            number: e.target.value
                                                        }))
                                                    }}
                                                    value={lotData.number}
                                                    sx={{
                                                        background: theme.palette.mode === "dark" ? colors.blue[200] : colors.blue[200],
                                                        width:1,
                                                        height:32,
                                                        px:1.5,
                                                        borderRadius:4,

                                                        "&.required-not-filled" : {
                                                            border: `1px solid ${colors.red[400]}`,
                                                            background: colors.red[100]
                                                        },
                                                        "&.required-filled" : {
                                                            border: `1px solid ${colors.green[400]}`,
                                                            background: colors.green[100]
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </Box>


                                        <ButtonBase
                                            disabled={createLotLoading}
                                            onClick={handleAddLot}
                                            sx={{
                                                mt:2,
                                                borderRadius:4,
                                                width:1,
                                                height:32,
                                                lineHeight:"32px",
                                                background: theme.palette.mode === "dark" ? colors.blue[400] : colors.blue[400],
                                                fontSize:14,
                                                fontWeight:"bold",
                                                fontFamily:"Roboto, sans-serif",
                                                color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["primary"]
                                            }}
                                        >
                                            {t("create_lot")}
                                        </ButtonBase>

                                    </Box>
                                }

                                <Box
                                    sx={{
                                        mt:2,
                                        flex:1,
                                        background:theme.palette.mode === "dark" ? colors.purple[100] : colors.purple[100],
                                        border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                        boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                        p:3,
                                        borderRadius:4,
                                    }}
                                >
                                    <Subheading>{t("shipments")}</Subheading>

                                    <Box
                                        sx={{
                                            display:"flex",
                                            gap:2,
                                            mt:1,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                height:24,
                                                borderRadius:3,
                                                minWidth:80,
                                                flex:1,
                                            }}
                                        >

                                            <Text light bold>{t("track_trace")}</Text>
                                        </Box>
                                    </Box>

                                    {inboundShipments.length === 0 &&
                                        <Box
                                            sx={{
                                                height:32,
                                                lineHeight:"32px",
                                            }}
                                        >
                                            <Text light>{t("no_results")}</Text>
                                        </Box>
                                    }

                                    {inboundShipments.map((shipment) => (
                                        <Box
                                            key={"inboundshipment"+shipment.id}
                                            sx={{
                                                display:"flex",
                                                gap:2,
                                                height:32,
                                                lineHeight:"32px"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    flex:1,
                                                    display:'flex',
                                                    justifyContent:'space-between',
                                                    alignItems:"center"
                                                }}
                                            >
                                                <Text>{shipment.trackandtrace}</Text>
                                                {/* A shipment created from an outbound label isn't ours to edit or remove here. */}
                                                {!shipment.shipmentId &&
                                                    <Box>
                                                        <ButtonBase
                                                            onClick={() => {
                                                                setShipmentToUpdate(shipment);
                                                                updateShipmentModal.setOpen(true);
                                                            }}
                                                            sx={{
                                                                borderRadius:4,
                                                            }}
                                                        >
                                                            <EditIcon fontSize="small"/>
                                                        </ButtonBase>

                                                        <ButtonBase
                                                            onClick={() => {
                                                                setShipmentToDelete(shipment);
                                                                confirmDeleteShipmentModal.setOpen(true);
                                                            }}
                                                            sx={{
                                                                ml:1,
                                                                borderRadius:4,
                                                                color:colors.red[400]
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small"/>
                                                        </ButtonBase>
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>
                                    ))}

                                    <ButtonBase
                                        onClick={() => addShipmentsModal.setOpen(true)}
                                        sx={{
                                            mt:2,
                                            borderRadius:4,
                                            width:1,
                                            height:32,
                                            lineHeight:"32px",
                                            background: theme.palette.mode === "dark" ? colors.purple[400] : colors.purple[400],
                                            fontSize:14,
                                            fontWeight:"bold",
                                            fontFamily:"Roboto, sans-serif",
                                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]
                                        }}
                                    >
                                        {t("add_inbound_shipments")}
                                    </ButtonBase>
                                </Box>

                            </Box>
                        </Box>
                        {spProductLoading && 
                            <SPStockDetails
                                isExtended={productsSpIsExtended}
                                setIsExtended={setProductsSpIsExtended}
                                productId={inboundLineToEdit.inboundLine.productId}
                            />
                        }
                    </Box>
                 
                :
                    <Box
                        sx={{
                            flex:1,
                            flexDirection: "column",
                            display:"flex",
                            p:2,
                            borderRadius:4,
                            position:'relative',
                            // borderTopLeftRadius:16,
                            // borderTopRightRadius:16,
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],

                        }}
                    >

                        <Box
                            sx={{
                                flex: 1,
                                borderRadius: 4,
                                // marginTop: 3,
                                paddingTop:4,
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                paddingBottom: 3,
                                justifyContent: 'center',  // To center contents vertically
                                alignItems: 'center',      // To center contents horizontally
                            }}
                        >
                            <img 
                                src="/img/barcode.svg" 
                                alt="Barcode" 
                                style={{
                                    width: '30%', 
                                    height: '30%', 
                                    objectFit: 'contain',
                                    animation: 'pulsate 1.5s infinite'
                                }} 
                            />

                            <Box display="flex"
                                height="32px"
                                // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[100]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                                <InputBase 
                                    sx={{
                                        ml: 2, 
                                        flex:1, 
                                        width: 248, 
                                        textAlign: 'center', 
                                        justifyContent: 'center'
                                    }} 
                                    placeholder={t("scan_type_barcode")}
                                    onKeyDown={handleKeyDown}
                                    autoFocus={!wasCounted}
                                />
                            </Box>
                        </Box>

                    </Box>
                }

           
                {/* {inboundLineToEdit !== null &&
                    <Box
                        sx={{
                            mt:3,
                            display:"flex",
                            justifyContent:"flex-end",
                            alignItems:"center",
                        }}
                    >
                        <ButtonBase 
                            onClick={handleCount}
                            ref={buttonRef}
                            disabled={popperShouldAppear()}
                            className={cx('', {
                                'disabled': popperShouldAppear(),
                            })}
                            sx={{
                                height:32,
                                px:2,
                                background:themeSettings(theme.palette.mode).palette.green.main,
                                color: themeSettings(theme.palette.mode).palette.green.contrastText,
                                borderRadius:4,
                                fontSize:14,
                                fontWeight:"bold",
                                "&.disabled" : {
                                    opacity:0.76
                                }
                            }}
                        >
                            {t("complete")}
                        </ButtonBase>
                        <Popper
                            open={popperShouldAppear()}            
                            anchorEl={anchorEl}   
                            placement="bottom-start"  
                            disableInteractive={true}  
                        >
                            <Box
                                sx={{
                                    mb:2,
                                    background: "#fff",
                                    padding: 2,
                                    boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.25)" : null,
                                    borderRadius: 4,
                                    zIndex: 9999, // Ensure it's above other elements
                                    maxWidth:350,
                                }}
                            >
                                <Subheading>{t("requirements_not_met")}</Subheading>
                                {checkLotAmount() && 
                                    <Box sx={{
                                        mt:2,
                                    }}>
                                        <Text bold>{t("lots")}</Text>
                                        <Text>{t("lot_insufficient_explanation")}</Text>
                                    </Box>
                                }
                                {checkBatchAmount() && 
                                    <Box sx={{
                                        mt:2,
                                    }}>
                                        <Text bold>{t("batches")}</Text>
                                        <Text>{t("batches_insufficient_explanation")}</Text>
                                    </Box>
                                }
                                {checkRepackAmount() && 
                                    <Box sx={{
                                        mt:2,
                                    }}>
                                        <Text bold>{t("repackingorders")}</Text>
                                        <Text>{t("repacking_insufficient_explanation")}</Text>
                                    </Box>
                                } 
                            </Box>
                        </Popper>
                    </Box>
                 }  */}
            </Box>
            

            <MCreateSerialNumber
                onOpen={() => createSerialNumberModal.setOpen(true)} 
                inboundLineId={inboundLineToEdit?.inboundLine.id}
                onClose={() => createSerialNumberModal.setOpen(false)} 
                open={createSerialNumberModal.open} 
                handleClose={handleCreateSerialNumberClose}
            />

            <MPrintInboundBarcodes
                open={printAllBarcodesModal.open}
                handleClose={() => printAllBarcodesModal.setOpen(false)}
                inboundlines={props.incData.inboundlines}
            />

            <MPrintSerialNumberBarcode
                open={printSnBarcodeModal.open}
                handleClose={() => printSnBarcodeModal.setOpen(false)}
                barcode={printSnBarcode}
                productId={inboundLineToEdit?.inboundLine.productId}
            />

            <MCreateRepackOrder
                open={createRepackOrderModal.open}
                handleClose={() => createRepackOrderModal.setOpen(false)}
                repackLeftToDo={repackLeftToDo}
                inboundLineToEdit={inboundLineToEdit}
                inboundId={props.incData.id}
                refetchJobAndLoad={refetchJobAndLoad}
            />
            <AMInboundToProcess 
                id={amStreamInProgressPopoverId}
                open={amStreamInProgressPopoverOpen}
                anchorEl={amStreamInProgressAnchorEl}
                onClose={handleAmStreamInProgressPopoverClose}
                setHighlightColor={props.setHighlightColor}
                inboundLineId={inboundLineToEdit?.inboundLine.id}
                item={item}
                onPrintBarcode={(barcode) => {
                    setPrintSnBarcode(barcode);
                    printSnBarcodeModal.setOpen(true);
                }}
                refetchJobAndLoad={refetchJobAndLoad}
            />

            <MConfirmationWithValue
                open={confirmModal.open}
                handleClose={() => confirmModal.setOpen(false)}
                data={confirmModal.data}
                confirm={confirmModal.confirm}
            />
            <MConfirmationWithValue
                open={completeInboundModal.open}
                handleClose={() => completeInboundModal.setOpen(false)}
                data={completeInboundModal.data}
                confirm={completeInboundModal.confirm}
            />
            <MLinkCostToInbound 
                open={linkCostModal.open}
                handleClose={() => linkCostModal.setOpen(false)}
                relationId={props.incData.relationId}
                inboundId={props.incData.id}
            />
            <MAddExtraSerialNumbers 
                open={addSnModal.open}
                handleClose={() => addSnModal.setOpen(false)}
                confirm={addSnModal.confirm}
            />

            {/* 
            <MConfirmationWithValue
                open={confirmCloseModal.open}
                handleClose={() => confirmCloseModal.setOpen(false)}
                data={confirmCloseModal.data}
                confirm={confirmCloseModal.confirm}
                // barcodeView={barcodeView}
            />
            <MConfirmationWithValue
                open={productAmountModal.open}
                handleClose={() => productAmountModal.setOpen(false)}
                data={productAmountModal.data}
                confirm={productAmountModal.confirm}
            /> */}
            <MUpdateLot 
                // onOpen={() => updateStockModal.setOpen(true)} 
                lot={lotToUpdate} 
                onClose={() => updateStockModal.setOpen(false)} 
                open={updateStockModal.open} 
                handleClose={handleUpdateStockClose}
            
            />
            <MUpdateBatch 
                // onOpen={() => updateStockModal.setOpen(true)} 
                batch={batchToUpdate} 
                onClose={() => updateBatchModal.setOpen(false)} 
                open={updateBatchModal.open} 
                handleClose={handleUpdateBatchClose}
            
            />
            <MAddInboundLine
                inboundId={props.incData.id}
                relationId={props.incData.relationId}
                supplierId={props.incData.supplierId}
                open={addInboundLineModal.open}
                onClose={() => addInboundLineModal.setOpen(false)}
                handleClose={handleAddInboundLineClose}
            />
             <MConfirmDelete
                open={confirmDeleteLotLotModal.open}
                handleClose={() => {
                    setLotToDelete(null);
                    confirmDeleteLotLotModal.setOpen(false)
                }}
                data={lotToDelete?.barcode}
                confirm={confirmDeleteLotLotModal.confirm}
            />
            <MConfirmDelete
               open={confirmDeleteBatchModal.open}
               handleClose={() => {
                   setBatchToDelete(null);
                   confirmDeleteBatchModal.setOpen(false)
               }}
               data={batchToDelete?.number}
               confirm={confirmDeleteBatchModal.confirm}
           />

            {inboundLineToEdit?.amounts?.received > inboundLineToEdit?.amounts?.moved &&
                <MInboundEditAmountReceived 
                    onOpen={() => updateAmountReceivedModal.setOpen(true)} 
                    amounts={inboundLineToEdit?.amounts} 
                    onClose={() => updateAmountReceivedModal.setOpen(false)} 
                    open={updateAmountReceivedModal.open} 
                    handleClose={handleAmountReicevedClose}
                    inboundId={props.incData?.id}
                    inboundLineId={inboundLineToEdit?.inboundLine?.id}
                />
            }

            <MLinePhotoCapture
                open={photoModalOpen}
                onClose={() => setPhotoModalOpen(false)}
                barcodeValue={`${stockhubInboundPreCode}-${props.incData?.id}-${inboundLineToEdit?.inboundLine?.id}`}
                photos={photosData || []}
                refetchPhotos={refetchPhotos}
                onUpload={handleUploadPhoto}
                onDelete={handleDeletePhoto}
                isUploading={isUploadingPhoto}
                isDeleting={isDeletingPhoto}
                isFetchingPhotos={photosFetching}
                initialMode={photoModalMode}
                onPhotosChanged={refetchPhotos}
                onPhotoClick={handlePhotoClick}
                showScanner={false}
            />

            <MAddInboundShipments
                inboundId={props.incData?.id}
                open={addShipmentsModal.open}
                onOpen={() => addShipmentsModal.setOpen(true)}
                onClose={() => addShipmentsModal.setOpen(false)}
                handleClose={() => addShipmentsModal.setOpen(false)}
            />

            <MUpdateInboundShipment
                inboundId={props.incData?.id}
                shipmentInfo={shipmentToUpdate}
                open={updateShipmentModal.open}
                onOpen={() => updateShipmentModal.setOpen(true)}
                onClose={() => updateShipmentModal.setOpen(false)}
                handleClose={() => {
                    setShipmentToUpdate(null);
                    updateShipmentModal.setOpen(false);
                }}
            />

            <MConfirmDelete
                open={confirmDeleteShipmentModal.open}
                handleClose={() => {
                    setShipmentToDelete(null);
                    confirmDeleteShipmentModal.setOpen(false);
                }}
                data={shipmentToDelete?.trackandtrace}
                confirm={confirmDeleteShipmentModal.confirm}
            />

            <MPhotoViewer
                open={photoViewerOpen}
                onClose={() => setPhotoViewerOpen(false)}
                photos={photosData || []}
                currentPhotoIndex={currentPhotoIndex}
                onPhotoChange={setCurrentPhotoIndex}
                onDelete={handleDeletePhoto}
                isDeleting={isDeletingPhoto}
            />
        </Box>
    )
}

export default InboundToProcessView;

const SelectWorkSpace = (props) => {
    const { t, ready } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const [selected, setSelected] = useState(-1);
    const [workTSpace,setTWorkSpace] = useState(selectedWorkSpace);

    const select = (selected) => {
        setTWorkSpace(data[selected]);
    }
    const { data: workSpaceData, isLoading } = useFindWorkspacesSelectQuery();

    useEffect(() => {
        if (!isLoading && workSpaceData) {
            const modifiedArray = workSpaceData.data.map(item => ({
                ...item,
                title: item.name
              }));
            
            setData(modifiedArray);
        }
    }, [workSpaceData, isLoading]);


    const selectWorkSpace = () => {
        dispatch(setWorkSpace({
            id:workTSpace.id,
            name:workTSpace.name,
        }));
    }

    useEffect(() => {
        if(data.length > 0) {
            for(var i = 0;i < data.length; i++) { 
                if(data[i].id === selectedWorkSpace.id){
                    setSelected(i);
                    // setSelected
                }
            }
        }
    }, [selectedWorkSpace,data]);


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return(
        <Box
            sx={{
                // py:3,
                // px:2,
                borderRadius:4,
            }}
        >
            
            <Box 
                sx={{
                    // paddingY:4,
                    // paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{props.subheading || t("select_workspace")}</Subheading>
            </Box>
            <Box
                sx={{
                    pt:3,
                }}
            >
                <SelectGroup 
                    customColors={{
                        selected: {
                            background:themeSettings(theme.palette.mode).palette.green.main,
                            foreground: themeSettings(theme.palette.mode).palette.green.contrastText,
                        },
                        default: {
                            background:colors.green[100],
                            foreground: colors.green[400],
                        }
                    }}
                
                selected={selected} setSelected={select} options={data} />
            </Box>
            
            <Box
                sx={{
                    paddingTop:3,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton block className={"group-btn"} color={theme.palette.mode === "dark" ? "primaryGreyOpposite" : "grey"} onClick={() => selectWorkSpace()} variant="contained">{t('select')}</Shbutton>
            </Box>
        </Box>
    )
}
